/**
 * Turkish catalogue — the source of truth.
 *
 * Written first and directly, not translated from English. Interface copy names
 * things by what the operator controls, not by how the system is built: the
 * navigation says "Onaylar", not "Approval queue consumer".
 */
export const tr = {
  // ---- Application chrome ----
  'app.name': 'Kimene',
  'app.tagline': 'Yapay zekâ iş gücü kontrol düzlemi',

  // ---- Navigation ----
  'nav.commandCenter': 'Komuta Merkezi',
  'nav.skipToContent': 'İçeriğe atla',
  'nav.organization': 'Organizasyon',
  'nav.projects': 'Projeler',
  'nav.missions': 'Görevler',
  'nav.agents': 'Ajanlar',
  'nav.liveOps': 'Canlı Operasyon',
  'nav.cockpit': 'Oturumlar',
  'nav.terminals': 'Terminaller',
  'nav.files': 'Dosyalar',
  'nav.approvals': 'Onaylar',
  'nav.pools': 'Havuzlar',
  'nav.system': 'Sistem',
  'nav.accounts': 'Hesaplar',
  'nav.models': 'Modeller',
  'nav.hosts': 'Sunucular',
  'nav.tools': 'Araçlar',
  'nav.artifacts': 'Çıktılar',
  'nav.analytics': 'Analitik',
  'nav.audit': 'Denetim',
  'nav.profile': 'Profil',
  'nav.settings': 'Ayarlar',
  'nav.collapse': 'Menüyü daralt',
  'nav.expand': 'Menüyü genişlet',

  // ---- Top bar ----
  'topbar.search': 'Ara',
  'topbar.searchPlaceholder': 'Proje, görev, hesap veya oturum ara',
  'topbar.live': 'Canlı',

  // ---- Top bar: the attention cluster ----
  'attn.calm': 'Bekleyen bir şey yok',
  'attn.waiting': '{count} oturum seni bekliyor',
  'attn.quota': 'En dar kota %{pct}',
  'attn.risks': '{count} risk',
  'attn.newBuild': 'Yeni sürüm — yenile',
  'attn.depDown': '{name} erişilemiyor',
  'topbar.activeOrchestrator': 'Aktif orkestratör',
  'topbar.runningTasks': 'Çalışan görev',
  'topbar.pendingApprovals': 'Bekleyen onay',
  'topbar.notifications': 'Bildirimler',
  'topbar.userMenu': 'Kullanıcı menüsü',
  'topbar.theme': 'Tema',
  // The screen wake lock, on a phone. Named for what it does to the device
  // rather than for the API: nobody is looking for "wake lock" in a menu, they
  // are looking for the reason the screen went dark while they were reading it.
  'topbar.keepAwake': 'Ekranı açık tut',
  'topbar.keepAwakeOn': 'Açık',
  'topbar.keepAwakeOff': 'Kapalı',
  // "Cihaz", not "bilgisayar": the same control is now the way in on a phone,
  // where a label promising to install on a computer is simply wrong.
  'topbar.installApp': 'Uygulamayı bu cihaza kur',
  'topbar.installAppHint':
    'Kimene’yi kendi penceresinde, sekmesiz bir uygulama olarak kurar. İstediğin zaman kaldırabilirsin.',
  'topbar.fullscreen': 'Tam ekran',
  // The layout switch beside it. Named for what it does to the screen, not for
  // the token it writes: "yoğunluk" is what the settings panel calls the same
  // three-value preference, and nobody hunting for a tighter screen mid-shift
  // is looking for a word about density.
  'topbar.tight': 'Sıkı yerleşim',
  'topbar.tightExit': 'Normal yerleşim',
  'topbar.tightHint': 'Boşlukları kapatır: tek çizgi kenarlıklar, kayıpsız alan.',

  /* ---- The install sheet on a phone (components/InstallOffer.tsx) ------- */
  // Kept short on purpose: this is a sheet over somebody's work, and the reason
  // to install has to fit on one line of a 390px screen. What it claims is what
  // installing actually changes — the chrome goes, the console keeps its place
  // in the task switcher, and it opens on the cockpit rather than on a tab.
  'install.title': 'Kimene’yi uygulama olarak kur',
  'install.why': 'Tarayıcı çubuğu olmadan tam ekran açılır, ana ekranda kendi simgesiyle durur.',
  'install.action': 'Kur',
  'install.dismiss': 'Kapat',
  'install.iosShare': 'Paylaş',
  'install.iosAdd': 'Ana Ekrana Ekle',
  'topbar.fullscreenExit': 'Tam ekrandan çık',
  'topbar.language': 'Dil',
  'topbar.logout': 'Çıkış yap',
  'topbar.account': 'Hesap',
  'nav.menu': 'Menü',

  // ---- Shared actions ----
  'action.create': 'Oluştur',
  'action.save': 'Kaydet',
  'action.cancel': 'Vazgeç',
  'action.confirm': 'Onayla',
  'action.delete': 'Sil',
  'action.edit': 'Düzenle',
  'action.close': 'Kapat',
  'action.retry': 'Yeniden dene',
  'action.refresh': 'Yenile',
  'action.viewAll': 'Tümünü gör',
  'action.details': 'Ayrıntılar',
  'action.approve': 'Onayla',
  'action.reject': 'Reddet',
  'action.pause': 'Duraklat',
  'action.resume': 'Sürdür',
  'action.stop': 'Durdur',
  'action.simulate': 'Benzet',
  'action.test': 'Sına',
  'action.login': 'Oturum aç',
  'action.continue': 'Devam et',
  'action.back': 'Geri',
  'action.next': 'İleri',

  // ---- Shared states ----
  'state.loading': 'Yükleniyor',
  'state.empty': 'Kayıt yok',
  'state.error': 'Bir sorun oluştu',
  'state.degraded': 'Sınırlı çalışıyor',
  'state.unknown': 'Bilinmiyor',
  'state.never': 'Hiç',
  'common.state': 'Durum',
  'project.description': 'Açıklama',
  'state.now': 'Şimdi',

  // ---- Errors and empty states ----
  'error.loadFailed': 'Veri yüklenemedi.',
  'error.loadFailedHint': 'Bağlantıyı denetleyip yeniden deneyin.',
  'error.notFound': 'Aradığınız kayıt bulunamadı.',
  'error.forbidden': 'Bu işlem için yetkiniz yok.',
  'error.forbiddenHint':
    'Yetkinizi denetleyin; kurulum sırasında bu genellikle anahtarın yanlış, süresi dolmuş ya da daha önce kullanılmış olduğu anlamına gelir.',
  'error.network': 'Sunucuya ulaşılamıyor.',
  'error.unexpected': 'Beklenmeyen bir hata oluştu.',

  // ---- Command centre ----
  'cc.title': 'Komuta Merkezi',
  'cc.subtitle': 'Sistemin şu anki durumu',
  'cc.systemHealth': 'Sistem sağlığı',
  'cc.activeExecutor': 'Aktif yürütücü',
  'cc.standbyRoute': 'Yedek rota',
  'cc.noStandby': 'Yedek rota yok',
  'cc.taskFlow': 'Görev akışı',
  'cc.running': 'Çalışıyor',
  'cc.waiting': 'Bekliyor',
  'cc.failed': 'Başarısız',
  'cc.needsYou': 'Sizi bekliyor',
  'cc.accountOverview': 'Hesap havuzu',
  'cc.hostResources': 'Sunucu kaynakları',
  'cc.hostCores': 'Çekirdek',
  'cc.hostMemory': 'Bellek',
  'cc.hostAccounts': 'Hesap',
  'cc.hostSessions': 'Oturum',
  'cc.hostStale': '{age} bildirim yok',
  'cc.recentRouteChanges': 'Son rota değişiklikleri',
  'cc.criticalRisks': 'Kritik riskler',
  'cc.liveEvents': 'Canlı olay akışı',
  'cc.dependencyHealth': 'Bağımlılık sağlığı',
  'cc.noEventsYet': 'Henüz olay yok. Bir görev başlattığınızda burada görünür.',
  'cc.noRisks': 'Bilinen kritik risk yok.',

  // ---- Routing / the decision strip ----
  'routing.decision': 'Rota kararı',
  'routing.why': 'Neden bu rota?',
  'routing.selected': 'Seçilen',
  'routing.candidates': 'Değerlendirilen adaylar',
  'routing.rejected': 'Elenen adaylar',
  'routing.score': 'Puan',
  'routing.scoreBreakdown': 'Puan bileşenleri',
  'routing.confidence': 'Güven',
  'routing.mode': 'Rota kipi',
  'routing.modeSource': 'Kip kaynağı',
  'routing.noEligible': 'Uygun aday bulunamadı',
  'routing.noEligibleHint':
    'Hiçbir hesap, model ve sunucu birleşimi bu görevin gereklerini karşılamıyor. Elenme nedenlerine bakın.',
  'routing.simulate': 'Rota benzetimi',
  'routing.simulateHint': 'Benzetim kira almaz ve oturum başlatmaz.',
  'routing.simulated': 'Benzetim',
  'routing.weights': 'Ağırlıklar',
  'routing.override': 'Elle seçim',

  // ---- Accounts ----
  'account.title': 'Hesap Havuzu',
  'account.subtitle': 'Sağlayıcı hesapları ve sunucu profilleri',
  'account.provider': 'Sağlayıcı',
  'account.label': 'Etiket',
  'account.host': 'Sunucu',
  'account.addHostHint':
    'Hesabın kimlik bilgileri bu sunucuda yaşar; onunla açılan oturumlar da orada çalışır.',
  'account.controlHostTag': 'kontrol',
  'account.auth': 'Kimlik',
  'account.capacity': 'Kapasite',
  'account.usage': 'Kullanım',
  'account.usageResets': '{when} sıfırlanır',
  'account.usageLeft': 'kaldı',
  'account.usageWindow.session': '5 saatlik',
  'account.usageWindow.weekly': 'Haftalık',
  'account.usageWindow.weeklyScoped': 'Haftalık · model',
  'account.usageWindow.monthly': 'Aylık',
  'account.spend': 'Harcama',
  'account.extraUsageOff': 'Ek kullanım kapalı',
  'account.subscription': 'Abonelik',
  'account.organization': 'Organizasyon',
  'account.confidence': 'Kapasite güveni',
  'account.models': 'Erişilebilir modeller',
  // Rotanın kendi uygunluk kararı. "Aktif kira" burada duruyordu; /accounts
  // böyle bir alan göndermiyor, gönderdiği yargı bu.
  'account.canAcceptWork': 'İş alabilir',
  'account.activeSessions': 'Açık oturum',
  'account.lastRateLimit': 'Son hız sınırı',
  'account.share': 'Tüm sunuculara aç',
  'account.sharedNow': 'Kimlik dizini paylaşımlı depoya taşındı; hesap artık her sunucuda kullanılabilir.',
  'account.everyHost': 'tüm sunucularda',
  'account.lastProbe': 'Son yoklama',
  'account.concurrency': 'Eşzamanlılık sınırı',
  'account.routingWeight': 'Rota ağırlığı',
  'account.enable': 'Etkinleştir',
  'account.disable': 'Devre dışı bırak',
  'account.healthTest': 'Sağlık sınaması',
  'account.openLogin': 'Oturum açma terminali',
  'account.signIn': 'Giriş yap',
  'account.reSignIn': 'Yeniden giriş',
  'account.reSignInConfirm':
    '{label} için bir giriş paneli açılır; akışı orada siz tamamlarsınız. Başarılı bir giriş, bu hesabın kimlik dizinindeki oturumu değiştirir — dizin paylaşımlıysa her sunucuda. Çalışan oturumlar kesilmez.',
  'account.add': 'Hesap ekle',
  'account.addTitle': 'Yeni hesap',
  'account.addProvider': 'Sağlayıcı',
  'account.addLabel': 'Etiket',
  'account.addLabelHint': 'Örn. Ekip-1 · Claude',
  'account.addManaged': 'Kimene kendi kimlik dizinini oluştursun',
  'account.addManagedHint':
    'Açık: taze, yalnızca-sahip bir dizin açılır ve girişi kokpitten yaparsınız. Kapalı: mevcut bir dizin yolu verirsiniz.',
  'account.addProfileDir': 'Kimlik dizini (mutlak yol)',
  'account.deviceAuth': 'Cihaz kodu ile giriş',
  'account.deviceAuthHint': 'Tarayıcı açılamayan sunucularda kod ile giriş yapar (yalnız Codex).',
  'account.addSubmit': 'Oluştur',
  'account.addThenSignIn': 'Oluştur ve giriş yap',
  'account.signInStarting': 'Giriş oturumu açılıyor…',
  // The pane opens here rather than on another screen; see SignInDialog.
  'account.signInPaneTitle': '{name} — giriş',
  'account.signInPaneHint':
    'Giriş akışı aşağıdaki terminalde çalışıyor; kodu oraya yapıştırın. Panel kapanınca giriş kendiliğinden doğrulanır.',
  'account.signInOpenInTerminal': 'Tam terminalde aç',
  'account.activate': 'Girişi doğrula',
  'account.signInThenActivate':
    'Giriş paneli bir terminalde açılır ve sizi oraya götürür; akışı orada tamamlarsınız. Panel kapanınca konsol girişi kendiliğinden doğrular — bu düğme, doğrulamayı elle yapmak için.',
  'account.activateNotReady':
    'Giriş henüz doğrulanamadı. Terminalde girişi tamamlayıp tekrar deneyin.',
  'account.matrix': 'Hesap × Model matrisi',
  'account.notConfigured': 'Yapılandırılmadı',
  'account.notConfiguredHint': 'Bu yuva henüz kurulmadı. Kurulumu başlatmak için düzenleyin.',
  'account.capacityUnknownHint':
    'Sağlayıcı kapasite bildirmiyor. Bu değer ölçülmedi; tahmin olarak da gösterilmez.',
  // Varlık: hesap bir sunucuya ait değil; hangi sunucu(lar)da ve son hangi
  // projelerde koştuğu yürütme geçmişinden türetilir (ADR: hiçbir havuz
  // diğerine sahip değil).
  'account.slotsTitle': 'Kurulmamış yuvalar',
  'account.reachModels': 'Modeller',
  'account.reachSessions': 'Oturum',
  'account.presence': 'Varlık',
  'account.noProjects': 'Henüz proje yürütülmedi',
  'account.reloginHint':
    'Bu hesabın kayıtlı girişi artık geçerli değil. İş alabilmesi için yeniden giriş yapın.',
  'account.delete': 'Sil',
  'account.deleteConfirm': '{label} hesabını kalıcı olarak sil? Bu işlem geri alınamaz.',
  'account.deleteDisableFirst': 'Silmeden önce hesabı devre dışı bırakın.',

  // ---- Models ----
  'model.title': 'Model Havuzu',
  'model.family': 'Aile',
  'model.status': 'Durum',
  'model.context': 'Bağlam',
  'model.capabilities': 'Yetenekler',
  'model.lastVerified': 'Son doğrulama',
  'model.availability': 'Erişilebilirlik',
  'model.verificationSource': 'Doğrulama kaynağı',

  // ---- Projects ----
  'project.title': 'Projeler',
  'project.repositories': 'Depolar',
  'project.overview': 'Genel bakış',
  'project.missions': 'Görevler',
  'project.tasks': 'İşler',
  'project.routing': 'Rota politikası',
  'project.performance': 'Model başarımı',
  'project.sessions': 'Oturumlar',
  'project.artifacts': 'Çıktılar',
  'project.configuration': 'Yapılandırma',
  'project.decisions': 'Kararlar',
  'project.audit': 'Denetim',
  'project.add': 'Proje ekle',
  'project.riskLevel': 'Risk düzeyi',
  'project.qualityGates': 'Kalite kapıları',
  'project.configHint':
    'Kimene bu dosyaları okur ve sessizce değiştirmez. Bir değişiklik gerekirse farkı gösterip onay ister.',

  // ---- Missions and tasks ----
  'mission.title': 'Görevler',
  'mission.objective': 'Amaç',
  'mission.acceptance': 'Kabul ölçütleri',
  'mission.graph': 'Bağımlılık grafiği',
  'mission.list': 'Liste',
  'mission.board': 'Pano',
  'mission.timeline': 'Zaman çizelgesi',
  'mission.criticalPath': 'Kritik yol',
  'mission.create': 'Görev oluştur',
  'task.state': 'Durum',
  'task.role': 'Rol',
  'task.archetype': 'İş türü',
  'task.duration': 'Süre',
  'task.progress': 'İlerleme',
  'task.evidence': 'Kanıt',
  'task.blocker': 'Engel',
  'task.dependencies': 'Bağımlılıklar',
  'task.attempts': 'Deneme',
  'task.openTerminal': 'Terminali aç',
  'task.evidenceIncomplete': 'Kanıt eksik',
  'task.evidenceComplete': 'Kanıt tamam',
  'task.evidenceHint': 'Bir iş, kanıt sözleşmesi karşılanmadan tamamlanmış sayılmaz.',

  // ---- Live operations and terminals ----
  'live.title': 'Canlı Operasyon',
  'live.sessions': 'Oturumlar',
  'live.terminal': 'Terminal',
  'live.messages': 'Görünür mesajlar',
  'live.timeline': 'Olay zaman çizelgesi',
  'live.toolActivity': 'Araç etkinliği',
  'live.changedFiles': 'Değişen dosyalar',
  'live.diff': 'Fark',
  'live.tests': 'Sınamalar',
  'live.metrics': 'Kaynak ölçümleri',
  'live.start': 'Oturum başlat',
  'live.stop': 'Durdur',
  'live.startTitle': 'Yeni oturum',
  'live.startAccount': 'Hesap',
  'live.continuedAccount': 'Bu projenin son kullandığı hesap',
  'live.startModel': 'Model',
  'live.startModelDefault': 'Varsayılan (CLI seçsin)',
  'live.startEffort': 'Çaba',
  'live.startEffortDefault': 'Belirtme',
  'live.startProject': 'Proje',
  'live.startProjectNone': 'Proje yok (yol gir)',
  'live.startProjectPick': 'Proje seç',
  'live.startRunsOn': 'Çalışacağı yer:',
  'live.startEveryHost': 'tüm sunucular',
  'live.startOtherRepos': '{n} depo daha var, bu oturum burada çalışacak',
  // The credential is on one machine (ADR-0006). Said when the project is
  // picked, not after Start is pressed, and it names the remedy.
  'live.startAccountElsewhere':
    '{account} hesabı {on} sunucusunda oturum açmış, bu oturum ise {target} üzerinde çalışacak. Kimlik bilgileri sunucuya özeldir: bu hesabı Hesaplar ekranından {target} üzerinde de oturum açtırın ya da {target} üzerinde açılmış bir hesap seçin.',
  'live.startProjectNoRepo': 'Bu projede depo (sunucu + dizin) yok. Proje sayfasından ekleyin.',
  'live.startWorkingDir': 'Çalışma dizini',
  'live.startWorkingDirHint': 'Mutlak yol, örn. /srv/kimene',
  'live.startName': 'Ad (isteğe bağlı)',
  'live.startRecord': 'Oturumu kaydet',
  'live.startResume': 'Önceki oturumu sürdür',
  'live.startResumeHint': 'Yeni konuşma yerine sağlayıcının geçmiş oturum seçicisini açar.',
  'live.startBypass': 'Onayları atla (tehlikeli mod)',
  'live.startBypassHint': "CLI'yi denetimsiz, onay sormayan modda başlatır.",
  'live.startBypassWarn':
    'Bu mod sağlayıcının onay ve sandbox korumalarını devre dışı bırakır. Yalnız güvendiğiniz işlerde kullanın.',
  'live.startSubmit': 'Başlat',
  'live.startNoAccounts': 'Etkin hesap yok. Önce bir hesap ekleyip giriş yapın.',
  'live.stopConfirm': 'Bu oturum durdurulsun mu? tmux oturumu sonlandırılacak.',
  'live.switchAccount': 'Hesabı değiştir',
  'live.switchAccountBusy':
    'Ajan şu an çalışıyor. Hesabı değiştirmek oturumu yeniden başlatır ve bir turun ortasında kesmek işi yarım bırakabilir — turun bitmesini ya da bir soru sormasını bekleyin.',
  'live.switchTo': 'Yeni hesap',
  'live.switchToHint': '{host} üzerinde oturum açmış, aynı sağlayıcıya ait hesaplar.',
  'live.switchPick': 'Hesap seçin…',
  'live.switchNoneHere':
    '{host} üzerinde bu oturumun devam edebileceği başka hesap yok. Kimlik bilgileri sunucuya özeldir; başka bir makinede açılmış oturum buradan kullanılamaz.',
  'live.switchWarning':
    'Bu oturum durdurulup seçtiğiniz hesapla yeniden başlatılacak. Konuşma geçmişi eski hesabın dizininde kalır ve yeni oturum boş bir konuşmayla açılır. Proje, dizin ve model aynı kalır.',
  'live.switchConfirm': 'Durdur ve yeniden başlat',
  'live.handoff.failure': 'Bu oturum onaylı bir hatayla durdu ({reason}); işi başka bir hesaba taşımak gerekiyor.',
  'live.handoff.recommend': 'Önerilen: {account}.',
  'live.handoff.carries': 'Devir bir özet taşır: yeni oturum, bu oturumun ne yaptığını bilerek kaldığı yerden devam eder.',
  'live.restart': 'Yeniden başlat',
  'live.restartConfirmRunning':
    'Bu oturum durdurulup aynı ayarlarla yeniden başlatılsın mı? Süren iş kaybolur.',
  'live.restartConfirmEnded': 'Bu oturum aynı ayarlarla yeniden başlatılsın mı?',
  // "Durdur" ends work; this one only clears away what an ended session left
  // behind — the dead tmux pane and the row. The verdict stays on the record.
  'live.clear': 'Listeden kaldır',
  'live.clearConfirm':
    'Bu bitmiş oturum listeden kaldırılsın mı? Sunucudaki ölü tmux bölmesi de temizlenir.',
  'live.exitStatus': 'çıkış {code}',
  'live.exitLabel': 'Çıkış kodu',
  'live.approvals': 'Onaylar',
  'live.approvalsBypassed': 'Atlanıyor',
  'live.recording': 'Kayıt',
  'live.recordingOn': 'Açık',
  'live.sessionId': 'Oturum kimliği',
  'live.effort': 'Çaba',
  'live.runningFor': '{duration} çalışıyor',
  'live.ranFor': '{duration} sürdü',

  // ---- Live: telemetry rail ----
  'live.rail.quotas': 'Kotalar',
  'live.rail.waiting': 'Seni bekleyenler',
  'live.rail.quietWaiting': 'Bekleyen yok',
  'live.risk.duplicate_identity':
    '{accounts} aynı abonelik: sağlayıcı ikisini de {email} olarak bildiriyor. Yönlendirme ikisini tek izin sayıyor, ama etiketlerden biri yanlış: adını taşıdığı hesapla yeniden bağla, yoksa o abonelik hiç kullanılmıyor.',
  'live.risk.duplicate_identity_plain':
    '{accounts} aynı abonelik. Yönlendirme ikisini tek izin sayıyor, ama etiketlerden biri yanlış: adını taşıdığı hesapla yeniden bağla, yoksa o abonelik hiç kullanılmıyor.',
  'live.ctx.noHost': 'Bu oturumun sunucusu envanterde yok.',
  'live.ctx.noAccount': 'Hesap kaydedilmemiş',
  'live.ctx.noQuota': 'Kota ölçülmedi.',
  'live.rail.risks': 'Riskler ve uyarılar',
  'live.rail.quotaRefresh': 'Kotaları şimdi oku',
  'live.rail.quotaResets': '{when} sıfırlanıyor',
  'live.rail.quotaAsOf': '{when} okundu',
  'live.rail.quotaNotStarted': 'Bu pencere henüz açılmadı',
  'live.rail.quotaNoReset': 'Sıfırlama zamanı bildirilmedi',
  'live.rail.quotaRun': '{kind} sıfırlanana dek ~{count} pencere',
  'live.rail.quotaRunMeasured': 'Sağlayıcının bildirdiği {hours} saatlik pencere uzunluğundan hesaplandı.',
  'live.rail.quotaRunAssumed': 'Pencere {hours} saat varsayılarak hesaplandı; sağlayıcı bu uzunluğu yayınlamıyor.',
  'live.rail.noQuotas': 'Yayınlanan kota yok.',
  'live.rail.quietRisks': 'Açık risk yok',
  'live.rail.quotaMore': '+{count} pencere',
  'live.rail.quotaFewer': 'Daha az',
  'live.metric.cpu': 'CPU',
  'live.metric.ram': 'RAM',
  'live.metric.disk': 'Disk',
  'live.metric.gpu': 'GPU',
  'live.metric.load': 'yük',
  'live.metric.cores': '{count} çekirdek',
  'live.metric.stale': 'bayat',
  'live.metric.noSample': 'örnek yok',
  'live.risk.host_offline': '{host} sunucusu çevrimdışı',
  'live.risk.node_contract_differs': '{host} üzerindeki ajan farklı bir sürüm çalıştırıyor; güvenli bir sınırda yeniden başlatmak çalıştırdığını değiştirir.',
  'live.risk.host_stale': '{host} uzun süredir bildirmiyor',
  'live.risk.host_disk_high': '{host} diski %{percent} dolu',
  'live.risk.account_auth': '{account} hesabı giriş bekliyor',
  'live.risk.account_exhausted': '{account} kota sınırına ulaştı',
  'live.risk.no_eligible_account': 'İş kabul edebilecek hesap yok',
  'live.risk.dependency_down': '{dependency} erişilemiyor',
  // The console admitting what it cannot show. Names them, because "there is
  // one somewhere" is not something an operator can act on.
  'live.risk.unlisted_sessions': 'Sunucuda listelenemeyen {count} oturum: {sessions}',
  // And the quieter half: a pane whose command has exited is a corpse the
  // steward collects on its own. Saying so is what stops it reading as
  // something the operator has to chase.
  'live.risk.unlisted_dead': 'Biten {count} oturum sunucuda duruyor, kendiliğinden temizlenecek: {sessions}',
  'live.rail.clearUnlisted': 'Şimdi temizle',
  'live.rail.clearUnlistedHint': 'Biten oturumları beklemeden sunucudan sil. Çalışan bir oturuma dokunulmaz.',
  'live.rail.clearUnlistedFailed': 'Temizlenemedi. Sunucu günlüğü nedenini yazar.',
  'live.resizeSessions': 'Oturum sütununu yeniden boyutlandır',
  'live.resizeRail': 'Telemetri sütununu yeniden boyutlandır',
  'live.hideSessions': 'Oturum panelini gizle',
  'live.showSessions': 'Oturum panelini göster',
  'live.hideRail': 'Telemetri panelini gizle',
  'live.showRail': 'Telemetri panelini göster',
  'live.open': 'Terminalde aç',
  'live.copyId': 'Kimliği kopyala',
  'terminal.control': 'Devral',
  'terminal.attach': 'Bağlan',
  'terminal.detach': 'Ayrıl',
  // Distinct from "Ayrıl", which gives up the keyboard, and from "Oturumu
  // sonlandır", which ends the work. This one only stops showing the terminal.
  'terminal.close': 'Terminali kapat',
  'terminal.reconnect': 'Yeniden bağlan',
  'terminal.reconnecting': 'Yeniden bağlanılıyor',
  'terminal.disconnected': 'Bağlantı koptu',
  'terminal.controlHeld': 'Girdi denetimi başkasında',
  'terminal.controlYours': 'Girdi denetimi sizde',
  'terminal.recording': 'Kaydediliyor',
  'terminal.cancelTurn': 'Turu iptal et',
  'terminal.pauseAutomation': 'Otomasyonu duraklat',
  'terminal.terminate': 'Oturumu sonlandır',
  'terminal.fullscreen': 'Tam ekran',

  /* ---- The key bar on a touch device (terminal/KeyBar.tsx) -------------- */
  // Key *names*, not descriptions. These are the accessible names of twelve
  // 44px buttons whose faces are a glyph or an abbreviation, and the question
  // a screen reader user is asking is "which key is this" — so each is what the
  // key is called on a keyboard, in the language the console is in. Esc, Ctrl,
  // Alt, Tab, Home and End stay untranslated: they are what is printed on the
  // key, and a Turkish keyboard prints them the same way.
  'keybar.title': 'Terminal tuşları',
  'keybar.escape': 'Esc',
  'keybar.ctrl': 'Ctrl',
  'keybar.alt': 'Alt',
  'keybar.tab': 'Tab',
  'keybar.up': 'Yukarı ok',
  'keybar.down': 'Aşağı ok',
  'keybar.left': 'Sol ok',
  'keybar.right': 'Sağ ok',
  'keybar.home': 'Home',
  'keybar.end': 'End',
  'keybar.pageUp': 'Page Up',
  'keybar.pageDown': 'Page Down',
  'terminal.searchAt': '{at}/{total}',
  // Named for what it searches now. It used to open a search over the emulator's
  // buffer — which on the alternate screen is the visible screen and nothing
  // else — so "the output" meant the twenty lines already in front of the
  // operator. It opens the record instead, and the record is the history.
  'terminal.search': 'Geçmişte ara',
  'terminal.largePaste': 'Büyük yapıştırma',
  'terminal.largePasteHint': '{lines} satır yapıştırmak üzeresiniz. Terminale gönderilsin mi?',
  'terminal.linkConfirm': 'Bağlantıyı aç',
  'terminal.linkConfirmHint': 'Terminal çıktısındaki bu adres açılsın mı? {url}',
  'terminal.sessionKind.managed': 'Yönetilen',
  'terminal.sessionKind.adopted': 'Devralınan',
  'terminal.sessionKind.observed': 'Yalnızca izlenen',
  'terminal.observedHint':
    'Bu oturum denetlenebilir bir PTY içinde değil. Yalnızca izlenebilir; girdi gönderilemez.',
  'terminal.regionHint':
    'Terminal çıktısı ekran okuyucuya canlı olarak aktarılır. Geçmişte arama yapmak için “Geçmişte ara” düğmesini kullanın. Klavyeyi terminalden çıkarmak için F6, geriye çıkmak için Shift+F6 tuşuna basın.',
  'terminal.sessionDetached':
    'Oturum kopuk — iş sürüyor ama okunmuyor. Çıktı akmaz, tuşlar iletilmez; yeniden bağlanılıyor.',
  'terminal.controlHeldBy': 'Girdi denetimi {actor} kişisinde. Bırakmasını isteyin.',
  'terminal.seat': '{n}. panel — Cmd+S sonra {n}',
  'terminal.more': 'Diğer eylemler',
  'terminal.history': 'Geçmiş',
  'terminal.historyHint':
    'Oturumun kendi CLI’sının tuttuğu kayıt: konuşma, araç çağrıları ve sonuçları. Tam ekran arayüz çizen bir CLI terminalde kaydırılabilir bir geçmiş bırakmaz.',
  'terminal.historyLive': 'Canlıya dön',
  'terminal.historyOlder': 'Daha eskisi',
  'terminal.historyLines': '{from}–{to}. satırlar',
  'terminal.historyDroppedLines':
    'Daha eski {lines} satır bellekte tutulmuyor; kaynak kayıt diskte duruyor.',
  'terminal.historyMatches': '{matches} eşleşme',
  'terminal.historyNow': 'şu anda ekranda',
  'terminal.historyExtent': 'Kayıt penceresi: {from}–{to}, akış sonu {end}',
  'terminal.historyDropped':
    '{bytes} bayt eski çıktı arabellekten düştü; bu noktadan öncesi kayıtta yok.',
  'terminal.gatewayUnavailable':
    'Bu sunucu terminal geçidi olmadan çalışıyor. Oturuma bu ekrandan bağlanılamaz; sunucuda tmux ile bağlanın.',
  'session.activity.working': 'Çalışıyor',
  'session.activity.waiting': 'Onay bekliyor',
  'session.activity.done': 'Tur bitti',
  'session.activity.idle': 'Boşta',
  'session.activity.ended': 'Bitti',
  'session.activity.problem': 'Sorun var',
  'session.activity.unknown': 'Ölçülmedi',
  'terminal.dropImage': 'Görseli bırakın',
  'terminal.dropImageHint':
    'Görsel oturumun çalıştığı makineye yazılır ve yolu istem satırına eklenir. Cümlenizi siz yazarsınız.',
  'terminal.dropUploading': '{name} yükleniyor…',
  'terminal.dropDone': '{name} eklendi — yolu istem satırında.',
  'terminal.dropNeedsControl': 'Görsel eklemek için önce oturumun girdi denetimini devralın.',
  'terminal.dropNotImage': 'Yalnızca PNG, JPEG, GIF ve WebP görselleri eklenebilir.',
  'terminal.dropTooLarge': 'Bu görsel oturuma eklenemeyecek kadar büyük.',
  'terminal.dropFailed': 'Görsel eklenemedi: {reason}',

  // ---- Approvals ----
  'approval.title': 'Onaylar',
  'approval.subtitle': 'İnsan kararı bekleyen işlemler',
  'approval.inbox': 'Onay kutusu',
  'approval.action': 'İstenen işlem',
  'approval.requester': 'İsteyen',
  'approval.justification': 'Gerekçe',
  'approval.affected': 'Etkilenen kaynaklar',
  'approval.preview': 'Önizleme',
  'approval.rollback': 'Geri alma planı',
  'approval.alternatives': 'Seçenekler',
  'approval.ifDenied': 'Onaylanmazsa',
  'approval.policyRule': 'Politika kuralı',
  'approval.expires': 'Süre sonu',
  'approval.approveOnce': 'Bir kez onayla',
  'approval.approveModified': 'Değiştirerek onayla',
  'approval.requestClarification': 'Açıklama iste',
  'approval.delegate': 'Başkasına yönlendir',
  'approval.cancelTask': 'İşi iptal et',
  'approval.empty': 'Bekleyen onay yok.',
  'approval.emptyHint': 'Kritik bir işlem istendiğinde burada görünecek.',
  'approval.riskExplainer': 'Bu işlem {level} düzeyinde; politikaya göre insan onayı gerekir.',

  // ---- Hosts and nodes ----
  'host.title': 'Sunucu Havuzu',
  'host.add': 'Sunucu ekle',
  'host.address': 'Adres',
  'host.status': 'Durum',
  'host.nodeStatus': 'Ajan durumu',
  'host.capabilities': 'Yetenekler',
  'host.lastSeen': 'Son görülme',
  'host.bootstrap': 'Ajanı kur',
  'host.upgradeAgent': 'Ajanı yükselt',
  'host.upgradeAgentConfirm':
    '{host} üzerindeki ajan bu derlemeyle yeniden kurulsun mu? Ajan yeniden başlatılır; süren tmux oturumları etkilenmez.',
  'host.remove': 'Sunucuyu sil',
  'host.removeConfirm':
    '{host} kaydı silinsin mi? Yalnızca Kimene kaydı silinir, makineye dokunulmaz. Üzerinde hesap profili varsa sunucu bunu reddeder.',
  'host.agentCurrent': 'ajan güncel',
  'host.agentBehind': 'ajan farklı bir sürüm',
  'host.agentVersionUnknown': 'ajan sürümü bildirilmedi',
  'host.agentVersion': 'Ajan sürümü',
  'host.testConnection': 'Bağlantıyı sına',
  'host.provisionKey': 'Parola ile anahtar kur',
  'host.provisionKeyTitle': 'Parola ile SSH anahtarı kur',
  'host.provisionKeyHelp':
    '{host} ({address}) için parolayı bir kez gir. Kimene bir SSH anahtarı üretip kurar ve bundan sonra yalnız anahtarla bağlanır — parola hiçbir yerde saklanmaz.',
  'host.provisionKeyHint': 'Yalnız bu bağlantı için kullanılır; saklanmaz.',
  'host.provisionKeySubmit': 'Anahtarı kur',
  'host.password': 'Parola',
  'host.keyProvisioned': 'Anahtar kuruldu; bağlantı sınanıyor…',
  'host.check.tcp': 'Ağ erişimi',
  'host.check.hostKey': 'Sunucu anahtarı',
  'host.check.authentication': 'Kimlik doğrulama',
  'host.check.installPaths': 'Kurulum yolları',
  'host.check.inventory': 'Envanter',
  'host.check.sharedAccounts': 'Paylaşımlı hesap kökü',
  'host.cliBehind': '{latest} çıktı',
  'fleet.cliBehindCount': '{count} CLI eski',
  'fleet.totalCores': 'Çekirdek',
  'fleet.totalMemory': 'Bellek',
  'fleet.totalSessions': 'Oturum',
  'fleet.region.connection': 'Bağlantı',
  'fleet.region.tools': 'Araçlar',
  'host.fingerprint': 'Sabitlenmiş anahtar',
  'profile.title': 'Profil',
  'profile.subtitle': 'Kendi hesabınız',
  'profile.identity': 'Kimlik',
  'profile.username': 'Kullanıcı adı',
  'profile.role': 'Rol',
  'profile.mfa': 'İkinci faktör',
  'profile.mfaOn': 'Etkin',
  'profile.mfaOff': 'Yok',
  'profile.lastLogin': 'Son giriş',
  'profile.displayName': 'Görünen ad',
  'profile.displayNameHint': 'Boş bırakılırsa kullanıcı adınız kullanılır.',
  'profile.email': 'E-posta',
  'profile.emailHint': 'Yalnız kayıt için; Kimene buraya bir şey göndermez.',
  'profile.saved': 'Kaydedildi.',
  'profile.password': 'Şifre',
  'profile.passwordLede': 'Şifreyi değiştirmek, bu oturum dışındaki tüm oturumlarınızı sonlandırır.',
  'profile.currentPassword': 'Mevcut şifre',
  'profile.newPassword': 'Yeni şifre',
  'profile.newPasswordHint': 'En az 12 karakter.',
  'profile.confirmPassword': 'Yeni şifre (tekrar)',
  'profile.changePassword': 'Şifreyi değiştir',
  'profile.passwordChanged': 'Şifre değiştirildi. Diğer oturumlarınız sonlandırıldı.',
  'profile.mustChange': 'Bu hesap için şifre değişikliği isteniyor.',
  'fleet.stale': 'bayat',
  'fleet.col.host': 'Sunucu',
  'fleet.col.disk': 'Disk',
  'fleet.col.sessions': 'Oturum',
  'fleet.col.lastSeen': 'Görüldü',
  'fleet.col.cli': 'CLI',
  'fleet.selectAll': 'Tümünü seç',
  'fleet.bulkTitle': 'Toplu eylemler',
  'fleet.bulkSelected': '{count} seçili',
  'fleet.bulkNone': 'Toplu işlem için satır seçin',
  'account.selectOne': '{name} hesabını seç',
  'account.bulkNone': 'Toplu işlem için satır seçin',
  'fleet.bulkClear': 'Seçimi bırak',
  'fleet.bulkProgress': '{done}/{total} · {host}',
  'fleet.bulkDone': '{ok} tamam · {skipped} atlandı · {failed} hata',
  'host.cliAlreadyCurrent': 'Bu sunucu zaten güncel sürümü çalıştırıyor.',
  'host.cliInstallStarted': 'CLI kurulumu başlatıldı. İlerleme olay akışına düşer.',
  'host.cliUpdateOne': '{cli} güncelle',
  'host.cliInstallOne': '{cli} kur',
  'host.updateCLI': 'CLI\'ı güncelle',
  'host.fingerprintChanged': 'Sunucu anahtarı değişti',
  'host.fingerprintChangedHint':
    'Bu sunucunun SSH anahtarı beklenenden farklı. Kimene bunu kendiliğinden kabul etmez. Değişikliği doğrulayana kadar bağlanmayın.',

  // ---- Organisation ----
  'org.title': 'Organizasyon',
  'org.roleTemplates': 'Rol tanımları',
  'org.activeAgents': 'Aktif ajanlar',
  'org.roleHint': 'Rol bir görev tanımıdır; hiçbir hesaba kalıcı bağlı değildir.',

  // ---- Analytics ----
  'analytics.title': 'Analitik',
  'analytics.throughput': 'İş çıktısı',
  'analytics.modelPerformance': 'Model başarımı',
  'analytics.accountReliability': 'Hesap güvenilirliği',
  'analytics.routeSuccess': 'Rota başarısı',
  'analytics.firstPass': 'İlk seferde kabul',
  'analytics.rework': 'Yeniden çalışma',
  'analytics.humanIntervention': 'İnsan müdahalesi',
  'analytics.approvalLatency': 'Onay gecikmesi',
  'analytics.dataSource': 'Veri kaynağı',
  'analytics.sampleSize': 'Örnek sayısı',
  'analytics.insufficientData': 'Yeterli veri yok',
  'analytics.insufficientDataHint':
    'Güvenilir bir sonuç için en az {min} örnek gerekiyor; şu an {actual} var.',

  // ---- Audit ----
  'audit.title': 'Denetim Kaydı',
  'audit.actor': 'İşlemi yapan',
  'audit.action': 'İşlem',
  'audit.target': 'Hedef',
  'audit.result': 'Sonuç',
  'audit.client': 'İstemci',
  'audit.correlation': 'İlişki kimliği',
  'audit.detail': 'Ayrıntı',

  // ---- Settings ----
  'settings.title': 'Ayarlar',
  'settings.security': 'Güvenlik',
  'settings.routing': 'Rota ağırlıkları',
  'settings.retention': 'Saklama süreleri',
  'settings.sessions': 'Açık oturumlar',
  'settings.appearance': 'Görünüm',
  'settings.autonomy': 'Özerklik',
  'settings.other': 'Diğer ayarlar',

  // ---- Setup wizard ----
  'setup.title': 'Kimene kurulumu',
  'setup.subtitle': 'Birkaç adımda çalışır duruma getirin',
  'setup.step.owner': 'Yönetici hesabı',
  'setup.step.dependencies': 'Bağımlılık sağlığı',
  'setup.step.controlHost': 'Kontrol sunucusu',
  'setup.step.hosts': 'Sunucu ekleme',
  'setup.step.node': 'Ajan kurulumu',
  'setup.step.accounts': 'Sağlayıcı hesapları',
  'setup.step.projects': 'Proje ekleme',
  'setup.step.routing': 'Rota varsayılanları',
  'setup.step.orchestrator': 'Orkestratör politikası',
  'setup.step.finalCheck': 'Son denetim',
  'setup.bootstrapToken': 'Tek kullanımlık kurulum anahtarı',
  'setup.ownerEmail': 'E-posta (isteğe bağlı)',
  'setup.tokenHint':
    'Kimene, sahip hesabı oluşturulana kadar doğrulanacak bir kimlik tanımıyor. Bu yüzden anahtar sunucunun kendi günlüğüne yazılır ve yalnızca sunucuya erişebilen kişi okuyabilir. Almak için: sudo journalctl -u kimene-server -o cat | grep bootstrap_token | tail -1 — anahtar 30 dakika geçerlidir; süresi dolarsa servisi yeniden başlatın, yenisi üretilir.',
  'setup.ownerHint':
    'Bu hesap sistemin sahibidir. Parola en az 12 karakter olmalı ve Argon2id ile saklanır.',
  'setup.resume': 'Kurulum yarıda kalmış. Kaldığınız yerden sürdürün.',

  // ---- Authentication ----
  'auth.signIn': 'Kimene’ye giriş',
  'auth.operator': 'Operatör Girişi',
  'auth.heroTitle': 'Tüm yapay zekâ iş gücün, tek komuta konsolundan.',
  'auth.heroLede':
    'Havuzları sen tut — hesaplar, modeller, sunucular, projeler. İşi hangisinin yürüteceğine Kimene karar verir ve her kararı açıklanabilir tutar.',
  // Names the region, and deliberately not the tagline: the band across the top
  // already prints that, and printing it twice in one viewport is not emphasis.
  'auth.heroEyebrow': 'Kontrol düzlemi',
  'auth.heroThesis': 'Her yürütme için tek rota, tek karar, tek kayıt.',
  // Labels on the dispatch plate.
  'auth.routeAccount': 'Hesap',
  'auth.routeModel': 'Model',
  'auth.routeHost': 'Sunucu',
  'auth.routeProject': 'Proje',
  'auth.routeRole': 'Rol',
  'auth.routeEligibility': 'Uygunluk',
  'auth.routeDecision': 'Karar',
  'auth.routeRecord': 'Kayıt',
  'auth.routeUnmeasured': 'Ölçülmedi',
  'auth.routeExec': 'Yürütme',
  'auth.routeLive': 'Canlı',
  'auth.username': 'Kullanıcı adı',
  'auth.password': 'Parola',
  'auth.totp': 'Doğrulama kodu',
  'auth.invalidCredentials': 'Kullanıcı adı veya parola hatalı.',
  'auth.rateLimited': 'Çok fazla deneme yapıldı. {seconds} saniye sonra yeniden deneyin.',
  'auth.sessionExpired': 'Oturumunuz sona erdi. Yeniden giriş yapın.',

  // ---- Confidence levels ----
  'confidence.EXACT': 'Ölçüldü',
  'confidence.ESTIMATED': 'Tahmin',
  'confidence.INFERRED': 'Çıkarım',
  'confidence.UNKNOWN': 'Bilinmiyor',
  'confidence.EXACT.hint': 'Sağlayıcıdan gelen yapısal veriye dayanıyor.',
  'confidence.ESTIMATED.hint': 'Geçmiş kullanımdan hesaplandı.',
  'confidence.INFERRED.hint': 'Dolaylı olarak çıkarıldı; kesin değil.',
  'confidence.UNKNOWN.hint': 'Güvenilir bir veri yok. Bu değer ölçülmedi.',

  // ---- Risk levels ----
  'risk.L0_READ_ONLY': 'Salt okuma',
  'risk.L1_ISOLATED_WRITE': 'Yalıtılmış yazma',
  'risk.L2_VALIDATED_CHANGE': 'Doğrulanmış değişiklik',
  'risk.L3_EXTERNAL_OR_IRREVERSIBLE': 'Dışa açık / geri alınamaz',
  'risk.L4_FINANCIAL_OR_SECURITY': 'Finansal / güvenlik',

  // ---- Shared vocabulary ----
  'board.backlog': 'Sırada',
  'board.routing': 'Rotalanıyor',
  'board.blocked': 'Engelli',
  'board.review': 'İncelemede',
  'board.done': 'Tamamlandı',
  'mission.noSchedule': 'Zamanlama bilgisi olan iş yok.',
  'mission.project': 'Proje',
  'common.actions': 'İşlemler',
  'common.all': 'Tümü',
  'common.none': 'Yok',
  'common.yes': 'Evet',
  'common.no': 'Hayır',
  'common.filters': 'Süzgeçler',
  'common.clearFilters': 'Süzgeçleri temizle',
  'common.unmeasured': 'Kayıtlı değil — ölçülmedi, sıfır değil.',
  'common.loadMore': 'Daha fazla yükle',
  'common.copy': 'Kopyala',
  'common.copied': 'Kopyalandı',
  'common.cards': 'Kart',
  'common.table': 'Tablo',
  'common.view': 'Görünüm',
  'common.selectPrompt': 'Ayrıntı için listeden bir kayıt seçin.',
  'common.noMatches': 'Süzgeçlerle eşleşen kayıt yok.',
  'common.noMatchesHint': 'Süzgeçleri gevşetin ya da temizleyin.',
  'common.count': '{count} kayıt',
  'common.id': 'Kimlik',
  'common.name': 'Ad',
  'common.type': 'Tür',
  'common.category': 'Kategori',
  'common.created': 'Oluşturuldu',
  'common.updated': 'Güncellendi',
  'common.project': 'Proje',
  'common.task': 'İş',
  'common.expand': 'Genişlet',
  'common.collapse': 'Daralt',
  'common.exitFullscreen': 'Tam ekrandan çık',
  'common.required': 'Zorunlu',
  'common.optional': 'İsteğe bağlı',
  'common.saving': 'Kaydediliyor',
  'common.saved': 'Kaydedildi',
  'common.source': 'Kaynak',
  'common.latency': 'Gecikme',
  'common.reason': 'Neden',
  'common.enabled': 'Etkin',
  'common.disabled': 'Devre dışı',
  'common.searchPlaceholder': 'Listede ara',
  'common.notMeasured': 'Ölçülmedi',
  'common.version': 'Sürüm',
  'common.time': 'Zaman',
  'common.actionFailed': 'İşlem tamamlanamadı.',

  // ---- Command centre ----
  'cc.lastCheckpoint': 'Son kontrol noktası',

  // ---- Command centre: yürütücü paneli ----
  // /orchestrator/status tekil bir yürütücü değil, kiralanmış oturumların
  // listesini gönderir; yedek rota ve çit belirteci gibi kavramlar yanıtta yok.
  'cc.noExecutors': 'Kiralanmış yürütücü yok',
  'cc.noExecutorsHint':
    'Orkestratör bir iş yürüttüğünde kiraladığı oturum burada görünür. Orkestratörün kendisi durmuş değildir; şu anda yürüttüğü bir şey yoktur.',
  'cc.safeToSwitch': 'Yürütücü değiştirilebilir',
  'cc.unsafeToSwitch': 'Değiştirmek güvenli değil',
  'cc.pendingHandoffs': 'Bekleyen devir',
  'cc.awaitingApproval': 'Onay bekleyen iş',
  'cc.noCheckpoint': 'Kontrol noktası yok',
  'cc.noAccountAssigned': 'Hesap atanmadı',
  'cc.orchestratorUnavailable': 'Orkestratör durumu okunamadı.',
  'cc.orchestratorUnavailableHint':
    'Durum otuz saniyede bir yeniden denenir. Bu arada hangi yürütücünün çalıştığı bilinmiyor — çalışmadığı değil.',

  // ---- Accounts ----
  'account.empty': 'Tanımlı hesap yok.',
  'account.emptyHint': 'Rota motoru en az bir sağlayıcı hesabı olmadan çalışamaz.',
  'account.matrixHint': 'Satırlar hesap, sütunlar modeldir. Ayrıntı için bir hücre seçin.',
  'account.matrixEmpty': 'Matris için yeterli veri yok.',
  'account.matrixEmptyHint': 'En az bir hesap ve bir model tanımlı olmalı.',
  'account.neverVerified': 'Hiç doğrulanmadı',
  'account.preferred': 'Tercih edilen',
  'account.imported': 'İçe aktarıldı',
  // Yoklama istek içinde çalışıp sonucu döndürüyor; "başlatıldı" demek
  // operatörün sorduğu şeyi saklamaktı.
  'account.probeResult':
    'Yoklama bitti: {verified} erişilebilir, {unavailable} erişilemez, {unverified} doğrulanmadı.',
  'account.probeDetail': 'Sağlayıcı yanıtı',
  'account.openLoginHint':
    'Oturum açma terminali sunucu üzerinde açılır; kimlik bilgileri tarayıcıya hiç gelmez.',
  'account.availability.AVAILABLE': 'Erişilebilir',
  'account.availability.UNAVAILABLE': 'Erişilemez',
  'account.availability.UNVERIFIED': 'Doğrulanmadı',
  'account.availability.DEGRADED': 'Sorunlu',
  'account.availability.BLOCKED': 'Engellendi',
  'account.availability.NA': 'Bu sağlayıcıya uygulanamaz',

  // ---- Models ----
  'model.empty': 'Tanımlı model yok.',
  'model.emptyHint': 'Modeller sağlayıcı keşfiyle gelir. Bir hesap ekleyip yoklama çalıştırın.',
  'model.externalId': 'Sağlayıcı kimliği',
  'model.discoverySource': 'Keşif kaynağı',
  'model.lastDiscovered': 'Son keşif',
  'model.contextUnknown': 'Bağlam penceresi bildirilmedi',
  'model.cap.tools': 'Araç',
  'model.cap.vision': 'Görsel',
  'model.cap.structured': 'Yapısal çıktı',
  'model.cap.longContext': 'Uzun bağlam',
  'model.codeCapability': 'Kod yetkinliği',
  'model.tokens': '{count} belirteç',
  // Bağlam penceresi ile çıktı tavanı ayrı sınırlar; sağlayıcı ikisini ayrı
  // bildiriyor, ekran da ayrı gösteriyor.
  'model.maxOutput': 'En çok çıktı:',

  // ---- Hosts ----
  'host.empty': 'Tanımlı sunucu yok.',
  'host.emptyHint': 'Kimene işleri sunucular üzerinde çalıştırır. Önce bir sunucu ekleyin.',
  'host.controlHost': 'Kontrol sunucusu',
  'host.os': 'İşletim sistemi',
  'host.arch': 'Mimari',
  'host.cores': 'Çekirdek',
  'host.memory': 'Bellek',
  'host.disk': 'Disk',
  'host.gpu': 'GPU',
  'host.tooling': 'Araç envanteri',
  'host.installed': 'Kurulu',
  'host.missing': 'Yok',
  'host.user': 'Kullanıcı',
  'host.port': 'Port',
  'host.labels': 'Etiketler',
  'host.labelsPlaceholder': 'derleme, gpu',
  'host.addHint':
    'SSH ile erişilebilen bir sunucu tanımlayın. Kimene parola saklamaz; erişim anahtar tabanlıdır.',
  // Sınama istek içinde çalışıp bulduğunu döndürüyor; ekran sonucu gösteriyor,
  // "başlatıldı" demiyor.
  'host.testResult': 'Son bağlantı sınaması',
  'host.checkSkipped': 'Atlandı',
  'host.authMethod': 'Kimlik yöntemi',
  'host.fingerprintNone': 'Kayıtlı değil',
  // İlk temas olay değildir: kayıtlı anahtar yoksa değişen bir şey de yoktur.
  'host.fingerprintUnknown':
    'Bu sunucu için kayıtlı anahtar yok, dolayısıyla hiçbir şey doğrulanmadı. Makinenin kendisiyle karşılaştırın:',
  'host.bootstrapStarted': 'Ajan kurulumu başlatıldı.',
  'host.fingerprintExpected': 'Kayıtlı parmak izi',
  'host.fingerprintObserved': 'Görülen parmak izi',
  'host.fingerprintBlocked': 'Bu sunucuya bağlantı engellendi',
  'host.capabilitiesUnknown': 'Yetenekler henüz keşfedilmedi.',
  'host.nodeVersion': 'Ajan sürümü',
  // Filo — sunucu havuzunun canlı ana/ayrıntı görünümü. Ölçülmemiş asla sıfır
  // gibi gösterilmez; makine değerleri mono, bölge başlıkları görüntü yüzünde.
  'host.kernel': 'Kernel',
  'host.noSample': 'örnek yok',
  'host.staleFor': 'bayat {rel}',
  'host.neverSeen': 'hiç',
  'host.noGpu': 'GPU yok',
  'host.hiddenInList': 'Bu sunucu geçerli süzgeçlerle listede gizli.',
  'host.notDiscovered': 'Envanter henüz keşfedilmedi.',

  'fleet.title': 'Sunucular',
  'fleet.nodes': '{count} düğüm',
  'fleet.online': '{count} çevrimiçi',
  'fleet.shown': '{shown}/{total} görünen',
  'fleet.region.fleet': 'Sunucu filosu',
  'fleet.region.focus': 'Odak',
  'fleet.region.liveMetrics': 'Canlı ölçümler',
  'fleet.region.gpu': 'GPU bölmesi',
  'fleet.region.inventory': 'Envanter',
  'fleet.region.sort': 'Sırala',
  'fleet.region.filter': 'Filtre',
  'fleet.region.status': 'Durum',
  'fleet.region.pressure': 'Basınç',
  'fleet.reporting': '{n}/{m} raporluyor',
  'fleet.peak': 'tepe {pct}%',
  'fleet.inventoried': '{n}/{m} envanterli',
  'fleet.updated': 'yenilendi',
  'fleet.stream': 'akış',
  'fleet.pressure.calm': 'sakin',
  'fleet.pressure.warn': 'gergin',
  'fleet.pressure.crit': 'kritik',
  'fleet.pressure.unmeasured': 'ölçülmemiş',
  'fleet.sort.health': 'Sağlık',
  'fleet.sort.name': 'Ad',
  'fleet.sort.pressure': 'Yük',
  'fleet.sort.cpu': 'CPU',
  'fleet.sort.ram': 'RAM',
  'fleet.sort.disk': 'Disk',
  'fleet.sort.gpu': 'GPU',
  'fleet.sort.load': 'Yük ort.',
  'fleet.sort.sessions': 'Oturum',
  'fleet.sort.lastSeen': 'Son görülme',
  'fleet.sort.loadShort': 'Yük',
  'fleet.sort.lastSeenShort': 'Gör',
  'fleet.sortDir': 'Sıralama yönü',
  'fleet.sortAsc': 'Artan',
  'fleet.sortDesc': 'Azalan',
  'fleet.search': 'Sunucu ara',
  'fleet.searchPlaceholder': 'ad, adres, etiket…',
  'fleet.filter.gpu': 'GPU’lu',
  'fleet.filter.stale': 'Bayat',
  'fleet.filter.control': 'Kontrol',
  'fleet.clear': 'Temizle',
  'fleet.control': '#kontrol',
  'fleet.selectHost': 'Ayrıntı için bir sunucu seçin.',
  'fleet.back': 'Filo',
  'fleet.staleData': 'Ölçümler yenilenemedi; son bilinen değerler gösteriliyor.',
  'fleet.noMatches': 'Süzgeçlerle eşleşen sunucu yok.',
  'fleet.focus.sessions': 'Oturum',
  'fleet.focus.accounts': 'Hesap',

  // ---- Projects ----
  'project.empty': 'Proje yok.',
  'project.emptyHint':
    'Bir depo ekleyerek başlayın; Kimene yığını ve yapılandırmayı kendisi tarar.',
  'project.slug': 'Kısa ad',
  'project.configFile': 'Dosya',
  'project.configPresent': 'Var',
  'project.configMissing': 'Yok',
  'project.configHash': 'İçerik özeti',
  'project.configNotShown': 'İçerik gösterilmiyor',
  'project.configNotShownHint':
    'Bu dosyalar gizli bilgi taşıyabilir; Kimene içeriklerini tarayıcıya göndermez.',
  'project.lastScan': 'Son tarama',
  'project.fingerprint': 'Yapılandırma parmak izi',
  'project.noRepositories': 'Bu projeye bağlı depo yok.',
  'project.detectedStack': 'Algılanan yığın',
  'project.branch': 'Varsayılan dal',
  'project.remote': 'Uzak adres',
  'project.path': 'Yol',
  'project.newTitle': 'Yeni proje',
  'project.create': 'Oluştur',
  'project.name': 'Proje adı',
  'project.namePlaceholder': 'örn. Kimene',
  'project.descriptionHint': 'İsteğe bağlı kısa açıklama',
  'project.selectHost': 'Sunucu seç',
  'project.controlHost': 'kontrol',
  'project.pathPlaceholder': '/srv/kimene',
  'project.pathHint': 'Sunucudaki mutlak dizin yolu',
  'project.repoName': 'Depo adı (isteğe bağlı)',
  'project.repoNameHint': 'Boşsa yol/proje adından türetilir',
  'project.addRepository': 'Depo ekle',
  'project.addRepositoryTitle': 'Projeye depo ekle',
  'project.removeRepository': 'Depoyu kaldır',
  'project.removeRepositoryConfirm': '{name} deposu bu projeden kaldırılsın mı?',
  'project.noHosts': 'Önce Sunucular sayfasından bir sunucu ekleyin.',
  'project.noRepositoriesHint': 'Bir depo ekleyin: bir sunucu ve o sunucudaki mutlak dizin.',
  'project.noDecisions': 'Bu projede henüz rota kararı yok.',
  'project.noSessions': 'Bu projede açık oturum yok.',
  'project.noArtifacts': 'Bu projede çıktı yok.',
  'project.noPerformance': 'Model başarımı için yeterli veri yok.',

  // ---- Proje ayrıntısı: sekmeler, okuma, düzenleme, silme ----
  //
  // Bu ekranın sözlüğü iki şeyi ayırmaya çalışır: sunucuda *okunmuş* bir olgu
  // ile hiç okunmamış bir alan. "Yok" ölçülmüş bir yanıttır; "okunmadı" ise
  // yanıtın olmadığını söyler. İkisi aynı kelimeyle anlatılamaz.
  'project.tab.overview': 'Genel bakış',
  'project.tab.repositories': 'Depolar',
  'project.tab.sessions': 'Oturumlar',
  'project.tab.audit': 'Denetim',
  'project.backToList': 'Projeler',
  'project.identity': 'Kimlik',
  'project.policy': 'Politika',
  'project.routingNote':
    'Rota politikası tercih ve izin bildirir; hiçbir hesabı ya da modeli projeye bağlamaz.',
  'project.hosts': 'Sunucular',
  'project.location': 'Konum',
  'project.recentSessions': 'Son oturumlar',
  'project.gitRepositories': 'Git deposu',
  'project.openSessions': 'Açık oturum',
  'project.timezone': 'Saat dilimi',
  'project.created': 'Oluşturuldu',
  'project.updated': 'Güncellendi',
  'project.recordVersion': 'Kayıt sürümü',
  'project.qualityReviewer': 'Bağımsız gözden geçirici',
  'project.qualityCrossProvider': 'Farklı sağlayıcı zorunlu',
  'project.routingMode': 'Rota kipi',
  'project.allowProviderSwitch': 'Sağlayıcı değişimi',
  'project.allowModelSwitch': 'Model değişimi',
  'project.safeCheckpointOnly': 'Yalnızca güvenli noktada',

  // Tarama
  'project.scan': 'Depoları oku',
  'project.scanOne': 'Bu depoyu oku',
  'project.scanning': 'Okunuyor',
  'project.scanNever': 'Bu depo hiç okunmadı.',
  'project.scanNeverHint':
    '“Depoları oku” git bilgilerini, yığını ve yapılandırma dosyalarını sunucunun kendisinden alır.',
  'project.scanFailed': 'Depo okunamadı',
  'project.scanRead': 'Okundu',
  // ---- Proje listesi: bir projeyi okuduran şeyler ----
  'project.search': 'Proje, sunucu, dal, yığın ara',
  'project.filter.all': 'Hepsi',
  'project.filter.attention': 'İlgi bekleyen',
  'project.filter.running': 'Çalışan',
  'project.filter.unconfigured': 'Yapılandırılmamış',
  'project.noMatches': 'Aramayla eşleşen proje yok.',
  'project.noMatchesHint': 'Aramayı temizleyin ya da başka bir süzgeç seçin.',
  'project.matchCount': '{shown} / {total} proje',
  // Bir çalışma ağacının durumu. "Bilinmiyor" temiz değildir: tarama okuyamadı.
  'project.treeClean': 'temiz',
  'project.treeDirty': 'kaydedilmemiş değişiklik',
  'project.treeUnknown': 'ağaç durumu okunmadı',
  'project.onHost': '{host} üzerinde',
  'project.hostsN': '{count} sunucu',
  'project.branchesN': '{count} dal',
  'project.unreadN': '{count} depo hiç taranmadı',
  'project.brokenN': '{count} depo okunamıyor',
  'project.liveSessions': '{count} açık oturum',
  // Ajan yapılandırması: hangi CLI’ın projeye özgü yönergesi var.
  'project.agentClaude': 'Claude yönergeli',
  'project.agentCodex': 'Codex yönergeli',
  'project.agentKimene': 'Kimene dosyası',
  'project.credentialOverrideN': '{count} ayar hesabı geçersiz kılıyor',
  'project.credentialOverrideHint': 'Bu dizinde açılan her oturum, Kimene hangi hesabı seçerse seçsin, projedeki bu ayarın kimlik bilgisiyle çalışır.',
  'project.credentialOverrideTitle': 'Hesabı geçersiz kılan ayarlar',
  'project.credentialOverrideBody': 'Oturumun kimlik bilgisi hesaptan değil, bu dosyalardan geliyor. Yalnızca ayarın adı okunur — değeri sunucudan hiç çıkmaz.',
  'project.agentNone': 'Ajan yönergesi yok',
  'project.agentNoneHint':
    'Bu projede CLAUDE.md, AGENTS.md ya da .codex yok. Burada başlatılan bir ajan, projeye özgü hiçbir yönerge olmadan başlar.',
  'project.lastCommit': 'Son işlem',
  'project.openProject': 'Projeyi aç',

  'project.whereItRuns': 'Çalışma yeri',
  'project.agentInstructions': 'Ajan yönergesi',
  'project.agentPresentHint':
    'Burada başlatılan bir ajan, depodaki bu yönerge dosyalarını okuyarak başlar.',

  'project.scanUnread': 'Okunmadı',
  'project.scanStale': 'Bu bilgiler {when} okunmuştur.',
  'project.scanResult': '{read} depo okundu, {failed} depo okunamadı.',
  'project.scanNoRepositories': 'Okunacak depo yok; önce bir depo ekleyin.',

  // Git olguları
  'project.git': 'Git',
  'project.gitYes': 'Git deposu',
  'project.gitNo': 'Git deposu değil',
  'project.gitUnknown': 'Git durumu okunmadı',
  'project.gitMissingOnHost': 'Sunucuda git yok; git bilgileri okunamıyor.',
  'project.currentBranch': 'Bulunduğu dal',
  'project.head': 'Son işleme',
  'project.headAuthor': 'İşleyen',
  'project.dirty': 'Kaydedilmemiş değişiklik',
  'project.dirtyCount': '{count} dosya değişmiş',
  'project.clean': 'Çalışma ağacı temiz',
  'project.dirtyUnknown': 'Değişiklik durumu okunmadı',
  'project.pathMissing': 'Dizin sunucuda bulunamadı',
  'project.pathMissingHint':
    'Kimene bu yolu {host} üzerinde bulamadı. Yol taşınmış ya da silinmiş olabilir.',
  'project.gitRootDiffers': 'Depo kökü başka bir dizinde: {path}',
  'project.worktrees': 'Çalışma ağaçları',
  'project.worktreePrimary': 'ana',
  'project.worktreeDetached': 'ayrık',
  'project.worktreeLocked': 'kilitli',
  'project.worktreePrunable': 'artık',
  'project.commands': 'Komutlar',
  'project.buildCommand': 'Derleme',
  'project.testCommand': 'Test',
  'project.lintCommand': 'Lint',
  'project.worktreeRoot': 'Çalışma ağacı kökü',
  'project.commandsUnset':
    'Bu komutlar elle girilir; tarama onları tahmin etmez. Kalite kapıları bunlara dayanır.',
  'project.configInventoryTitle': 'Yapılandırma dökümü',
  'project.configFingerprintHint':
    'Parmak izi, aşağıdaki dosyaların içerik özetlerinden türetilir. Değişirse ajana verilen talimat değişmiştir.',
  'project.configFingerprintUnknown': 'Parmak izi alınamadı: sunucuda içerik özeti hesaplanamadı.',

  // Düzenleme
  'project.edit': 'Projeyi düzenle',
  'project.state': 'Durum',
  'project.stateHint':
    'ONBOARDING iş dağıtımını bekletir; ACTIVE işe açar; PAUSED ve ARCHIVED durdurur.',
  'project.activate': 'İşe aç',
  'project.saved': 'Kaydedildi.',

  // Silme
  'project.delete': 'Projeyi sil',
  'project.deleteTitle': '{name} silinsin mi?',
  'project.deleteMeaning':
    'Yalnızca Kimene’deki proje kaydı kaldırılır. Sunucudaki dizinler, depolar ve dosyalar olduğu gibi kalır.',
  'project.deleteChecks': 'Ön denetim',
  'project.deleteConsequences': 'Silmenin sonuçları',
  'project.deleteReady': 'Silmeyi engelleyen bir şey yok.',
  'project.deleteBlockedHint': 'Şunlar çözülmeden proje silinemez.',
  'project.deleteRecheck': 'Yeniden denetle',
  'project.deleteBlocker.activeSession':
    '{host} üzerinde açık bir oturum var ({provider}, {state}). Önce onu kapatın.',
  'project.deleteNote.repositories':
    'Kimene {count} depo kaydını unutur: {paths}. Dizinlere dokunulmaz.',
  'project.deleteNote.sessionHistory':
    '{count} geçmiş oturum bu projeye bağlı kalır ve okunabilir olmayı sürdürür.',
  'project.deleteNote.projectActive': 'Bu proje şu anda işe açık.',
  'project.deleted': 'Proje silindi.',

  // Oturumlar ve denetim sekmeleri
  'project.sessionsHistory': 'Bu projedeki oturumlar (geçmiş dahil)',
  'project.noSessionsEver': 'Bu projede hiç oturum açılmamış.',
  'project.noAudit': 'Bu projeye ait denetim kaydı yok.',
  'project.openInCockpit': 'Oturumu aç',

  // ---- Missions and tasks ----
  'mission.empty': 'Görev yok.',
  'mission.emptyHint': 'Bir görev, bir amacı işlere bölen kaptır. İlkini oluşturun.',
  'mission.priority': 'Öncelik',
  'mission.deadline': 'Son tarih',
  'mission.graphLoading': 'Grafik yükleniyor',
  'mission.noTasks': 'Bu görevde henüz iş yok.',
  'mission.criticalPathHint':
    'Kritik yol, görevin bitiş zamanını belirleyen en uzun bağımlılık zinciridir.',
  'mission.selectPrompt': 'Ayrıntı için bir görev seçin.',
  'task.account': 'Hesap',
  'task.model': 'Model',
  'task.host': 'Sunucu',
  'task.project': 'Proje',
  'task.routeScore': 'Rota puanı',
  'task.noRoute': 'Rota atanmadı',
  'task.noSession': 'Açık oturum yok',

  // ---- Live operations ----
  'live.empty': 'Açık oturum yok.',
  'live.emptyHint':
    'Bir iş çalışmaya başladığında oturumu burada belirir. Biten oturumlar da bir süre listede kalır.',
  'live.selectSession': 'Terminali görmek için bir oturum seçin.',
  // The sign-in pane's tail: the operator completes the flow in the terminal and
  // the console confirms the credential landed, where they already are.
  'live.signInConfirming': 'Giriş doğrulanıyor…',
  'live.signInConfirmed': 'Giriş doğrulandı. Hesap işe hazır.',
  'live.signInNotReady':
    'Giriş henüz doğrulanamadı. Terminalde akışı tamamlayıp tekrar deneyin.',
  'live.signInUnconfirmed': 'Giriş paneli kapandı. Kimliğin yerine oturduğu henüz doğrulanmadı.',
  'live.signInConfirmAction': 'Girişi doğrula',
  'live.signInAttemptFailed':
    'Giriş denemesi tamamlanmadı — yapıştırılan kod bu panele ait değildi. Her giriş kendi bağlantısını üretir; kodu bu panelin bağlantısından alın. Hesabın durumu aşağıda ayrıca kontrol edildi.',
  'live.layoutSingle': 'Tek',
  'live.layoutSplit': 'Bölünmüş',
  'live.layoutGrid': 'Izgara',
  'live.fit': 'Sığdır',
  'live.fitHint': 'Duvarın tamamını ekrana sığdır: her döşeme 24 satır kalır, yazı küçülür.',
  'live.fitDone': 'Ekrana sığdırıldı: {cols} × {rows} döşeme, {font} punto. Kapatmak için tıkla.',
  'live.fitTight': 'Bu kadar pano bu ekrana sığmıyor; en küçük puntoda bile kaydırma kalıyor.',
  'live.fitOnlyGrid': 'Yalnız ızgara düzeninde: tek ve bölünmüş zaten yüksekliği paylaşıyor.',

  // Çoklu seçim ve toplu eylemler.
  'live.selectOne': '{name} oturumunu seç',
  'live.bulkShowInGrid': 'Izgarada göster',
  'live.bulkRestart': 'Yeniden başlat',
  'live.bulkRestartConfirm': '{count} oturum yeniden başlatılsın mı? Süren iş kaybolur.',
  'live.bulkRestartConfirmSkipping':
    '{count} oturum yeniden başlatılacak. {skipped} tanesi şu an iş üstünde ve atlanacak — bir ajanı araç çağrısının ortasında kesmek işi yarım bırakır.',
  'live.bulkStop': 'Durdur',
  'live.bulkStopConfirm': '{count} oturum durdurulsun mu? Süren iş kaybolur.',
  'live.bulkClear': 'Listeden kaldır',
  'live.bulkClearConfirm': '{count} bitmiş oturum listeden kaldırılsın mı?',

  // Duvar: sürükleme, boyut, düzenler.
  // Elle sıralama, üç ekranın paylaştığı sözler: oturum listesi, sunucular,
  // hesaplar. Aynı cümleyi üç yere yazmak, üç ayrı ifadeye dönüşmenin yolu.
  'order.move': '{name} satırını taşı',
  // SSH konsolu: makinelerdeki kabuklar.
  // --- Kayıt oynatma -------------------------------------------------------
  'rec.title': 'Kayıt',
  'rec.note': 'Bitmiş bir oturumun tek geçmişi. Sunucuda satırlara çevrildi.',
  'rec.notRedacted': 'Bu kayıt redakte edilmeden yazılmış: yazılan her şeyi olduğu gibi tutuyor.',
  'rec.geometryUnknown':
    'Bu kaydın geometrisi yazılmamış; {cols}×{rows} varsayılarak çevrildi, yani satırlar özgün hâlinden kayabilir.',
  'rec.alternateScreen':
    'Bu oturum alt ekranda çiziyordu — orada hiçbir şey yukarı kaymaz, yani kayan bir geçmiş yok. Aşağıdaki son ekran.',
  'rec.lastScreen': 'Son ekran',
  'rec.open': 'Kaydı aç',

  // --- Dosyalar ------------------------------------------------------------
  'files.tab': 'Dosyalar',
  'files.repository': 'Depo',
  'files.noRepos': 'Bu projede kayıtlı depo yok.',
  'files.noReposHint': 'Depolar sekmesinden bir checkout kaydet; dosyalar onun kökünden okunur.',
  'files.empty': 'Bu dizin boş.',
  'files.emptyHint': 'Kök, deponun kendi yolu — dışına çıkılamaz.',
  'files.truncated': 'Bu dizin bir listede taşınabilecekten fazlasını tutuyor; bir kısmı gösterilmiyor.',
  'files.outside': 'kökün dışına çıkıyor',
  'files.newFolder': 'Klasör',
  'files.newFolderName': 'Klasör adı',
  'files.remove': '{name} sil',
  'files.removeConfirm': '{name} silinsin mi? Geri alınamaz.',
  'files.removeDirConfirm':
    '{name} silinsin mi? Yalnız boşsa silinir — dolu bir dizini bu boşaltmaz.',
  'files.binary': 'Bu dosya metin değil. Karar baytlara göre verildi, adına göre değil.',

  // --- Kabuk şablonları ----------------------------------------------------
  'tpl.delete': '{name} şablonunu sil',
  'tpl.group': 'Şablonlar',
  'tpl.command': 'İlk komut',
  'tpl.commandHint': 'Kabuk hazır olunca yazılır — elle yazmış gibi, ekranda görünür.',
  'tpl.saveAs': 'Şablon olarak kaydet',
  'tpl.saveAsHint': 'Bir ad ver; palette (F2) çıkar. Yalnız bu tarayıcıda saklanır.',

  // --- Klavye kısayolları --------------------------------------------------
  'keys.title': 'Klavye kısayolları',
  'keys.lede': 'Hepsi zaten çalışıyordu; burada yazılı olmayanları kimse bulamıyordu.',
  'keys.groupConsole': 'Konsol',
  'keys.groupPane': 'Terminal paneli',
  'keys.groupWall': 'Duvar',
  'keys.palette': 'Komut paletini aç',
  'keys.dismiss': 'Kapat',
  'keys.leavePane': 'Panelden çık (klavyeyi geri al)',
  'keys.forceSelect': 'Sürüklerken: uygulama fareyi dinlese de seçim yap',
  'keys.copyMove': 'İmleci gezdir',
  'keys.copyYank': 'Panoya al ve çık',
  'keys.dragStart': 'Sürüklemeyi başlat ve bırak',
  'keys.dragMove': 'Sürüklerken taşı',
  'keys.spanResize': 'Döşemeyi büyüt / küçült',
  'keys.exitFull': 'Tam ekrandan çık',
  'keys.paneFull': 'Odaktaki paneli tam ekran yap / geri al',
  'keys.seat': 'Numarasıyla panele geç (duvardaki sıra)',
  'keys.control': 'Devral / girdi denetiminden ayrıl',
  'keys.historyOpen': 'Oturumun kaydını aç',
  'keys.backToLive': 'Canlıya dön',
  'keys.scopeRecord': 'kayıt açıkken',
  'keys.scopeWall': 'duvarda',
  'keys.help': 'Klavye kısayollarını göster',
  'keys.groupPalette': 'Komut paleti',
  'keys.groupCopy': 'Kopyalama modu',
  'keys.paletteMove': 'Listede gez',
  'keys.paletteRun': 'Seçili komutu çalıştır',
  'keys.leavePaneBack': 'Panelden geriye çık',
  'keys.findNext': 'Sonraki eşleşme',
  'keys.findPrev': 'Önceki eşleşme',
  'keys.copyLineEnds': 'Satır başı / sonu',
  'keys.copyPage': 'Sayfa yukarı / aşağı',
  'keys.copyHalfPage': 'Yarım sayfa yukarı / aşağı',
  'keys.copyAnchorLine': 'Satır seçimi başlat (yine basınca bırakır)',
  'keys.copyAnchorChar': 'Karakter seçimi başlat (yine basınca bırakır)',
  'keys.copyLeave': 'Kopyalama modundan çık',
  'keys.copyVim': 'Aynı hareketlerin vim karşılıkları',
  'keys.scopePalette': 'palet açıkken',
  'keys.scopeFind': 'arama kutusu açıkken',
  'keys.scopeAnywhere': 'her yerde',
  'keys.files': 'Dosyalar panelini aç/kapat',
  'keys.scopeOverlay': 'açık katmanda',
  'keys.scopePane': 'panelin içinde',
  'keys.scopeCopy': 'kopyalama modunda',
  'keys.scopeGrip': 'tutamak odaktayken',
  'keys.scopeDragging': 'sürükleme sürerken',
  'keys.scopeSpan': 'boyut köşesi odaktayken',
  'keys.scopeFull': 'panel tam ekranken',

  // --- Kopyalama modu ------------------------------------------------------
  'copy.mode': 'Kopyala',
  'copy.leave': 'Kopyalama kipinden çık',
  'copy.hint': 'Klavyeyle seç ve panoya al (vim tuşları)',
  'copy.char': 'karakter',
  'copy.line': 'satır',
  'copy.yank': 'al',
  'copy.cursor': 'imleç',
  'copy.taken': '{n} karakter panoya alındı',

  // --- Komut paleti --------------------------------------------------------
  'palette.title': 'Komut paleti',
  'palette.open': 'Komut paleti (F2)',
  'palette.placeholder': 'Bir eylem yaz…',
  'palette.none': 'Eşleşen eylem yok',
  'palette.groupOpen': 'Kabuk aç',
  'palette.groupPanes': 'Paneller',
  'palette.groupLayouts': 'Kayıtlı düzenler',
  'palette.groupView': 'Görünüm',
  'palette.openOn': '{host} üzerinde kabuk aç',
  'palette.show': 'Izgarada göster',
  'palette.hide': 'Duvardan kaldır',
  'palette.close': 'Oturumu kapat',

  // --- Yayın modu: bir kez yaz, birden çok kabuğa gitsin -------------------
  'cast.on': 'Yayın',
  'cast.off': 'Yayını kapat',
  'cast.hint': 'Yazdığın her tuş, dinleyen tüm panellere gider.',
  'cast.count': '{n} panel dinliyor',
  'cast.none': 'Dinleyen panel yok',
  'cast.mute': 'Bu paneli yayından çıkar',
  'cast.unmute': 'Bu paneli yayına al',
  'cast.armed': 'Yayın açık — {n} panel dinliyor',

  'ssh.showShells': 'Kabukları göster',
  'ssh.hideShells': 'Kabukları gizle',
  'ssh.resize': 'Kabuklar sütununu yeniden boyutlandır',
  'ssh.title': 'Terminaller',
  'ssh.subtitle': 'Sunuculardaki kabuklar — ajan yok, hesap yok',
  'ssh.open': 'Kabuk aç',
  'ssh.open.title': 'Açık kabuklar',
  'ssh.wall': 'Kabuk duvarı',
  'ssh.wallEmpty': 'Görmek için bir kabuk seçin.',
  'ssh.wallEmptyHint': 'Soldaki listeden bir kabuğa tıklayın ya da duvara sürükleyin.',
  'ssh.empty': 'Açık kabuk yok.',
  'ssh.emptyHint': 'Bir sunucuya bağlanmak için "Kabuk aç" deyin.',
  'ssh.host': 'Sunucu',
  'ssh.hostPick': 'Bir sunucu seçin',
  'ssh.label': 'Ad',
  'ssh.labelHint': 'Listede ve tmux adında görünür. Boş bırakılırsa sunucunun adı.',
  'ssh.workingDir': 'Başlangıç dizini',
  'ssh.workingDirHint': 'Mutlak yol. Boş bırakılırsa oturumun ev dizini.',
  'ssh.record': 'Bu kabuğu kaydet',
  'ssh.recordHint':
    'Kayıt ham terminal baytlarıdır: yazılan her şeyi tutar, yapıştırılan bir parola dahil. Oturum bitince geriye kalan tek geçmiş odur; yalnız Yönetici ve Sahip okuyabilir ve saklama süresi dolunca silinir.',
  'ssh.noHosts': 'Çevrimiçi sunucu yok.',
  'ssh.closeMany': 'Kapat',
  'ssh.closeManyConfirm': '{count} kabuk kapatılsın mı? İçlerinde süren iş varsa kaybolur.',
  'order.select': 'Satır seç',
  'order.selectDone': 'Seçimi kapat',
  'order.selectAllShown': 'Görünen tümünü seç',
  'order.manual': 'Sıra senin',
  'order.reset': 'Otomatik sıraya dön',
  'live.wallMove': 'Duvarda taşı',
  'live.wallResize': 'Panel boyutu',
  'live.wallLayouts': 'Düzenler',
  'live.wallSave': 'Bu düzeni kaydet',
  'live.wallSavePrompt': 'Düzenin adı',
  'live.wallLost': 'Bu düzenin {count} paneli artık yok: {names}',
  'live.wallDelete': '{name} düzenini sil',
  'live.wallLocal': 'Düzen bu tarayıcıda saklanır.',
  'live.wallEmpty': 'Kayıtlı düzen yok.',
  'live.wallDrifted': 'Duvar bu kayıttan farklı; sekmeye basmak kaydı geri getirir.',
  'live.wallPending': 'Görünür olunca bağlanır',
  'order.dragStart': '{name} alındı. Yerleştirmek için ok tuşları, bırakmak için boşluk.',
  'order.dragOver': '{name} üzerinde.',
  'order.dragEnd': '{name} konumuna bırakıldı.',
  'order.dragCancel': 'Taşıma iptal edildi.',
  'live.layout': 'Terminal düzeni',
  'live.noMessages': 'Görünür mesaj yok.',
  'live.noToolActivity': 'Araç etkinliği yok.',
  'live.noChangedFiles': 'Değişen dosya yok.',
  'live.noDiff': 'Gösterilecek fark yok.',
  'live.noTests': 'Sınama çalıştırılmadı.',
  'live.noMetrics': 'Ölçüm yok.',
  'live.turns': 'Tur',
  'live.workingDir': 'Çalışma dizini',
  'live.branch': 'Dal',
  'live.waitingReason': 'Bekleme nedeni',
  'live.testsPassed': 'Geçti',
  'live.testsFailed': 'Kaldı',
  'live.testsSkipped': 'Atlandı',
  'live.sessionKind': 'Oturum türü',
  'live.kindHint.managed': 'Kimene başlattı ve sürdürüyor: durdurabilir, yeniden başlatabilir, klavyeyi devralabilirsiniz.',
  'live.kindHint.adopted': 'Kimene başlatmadı, sizin onayınızla devraldı: yönetilen bir oturum gibi sürebilirsiniz.',
  'live.kindHint.observed': 'Kimene görüyor ama sürebileceği bir uç yok: yalnızca izlenir, girdi gönderilemez.',
  'live.tmuxSession': 'tmux oturumu',
  'live.toolCalls': 'Araç çağrısı (başarılı / başarısız)',
  'live.endedAt': 'Bitiş',
  // An ended session stays in the list for a while; the row has to say so, or it
  // reads as a live one whose light happens to be a different colour.
  'live.endedAgo': 'bitti · {when}',
  'live.endedFailed': 'başarısız · {when}',
  'live.checkpoints': 'Kontrol noktaları',
  'live.checkpointSummary': 'Özet',
  'live.noCheckpoints': 'Bu oturumda kontrol noktası yok.',
  'live.safeBoundary': 'Güvenli sınır',
  'live.repositoryState': 'Depo durumu',
  'live.dirtyFiles': '{count} değişmiş dosya',
  'live.timelineLiveOnly':
    'Bu çizelge, konsolun bağlandığı andan sonraki olayları gösterir. Oturum geçmişi sunulmuyor.',
  'live.truncated':
    'Sunucu listenin ilk sayfasını verdi. Buradaki süzgeçler yalnızca bu sayfada çalışır; eşleşen başka oturumlar olabilir.',

  // ---- Approvals ----
  'approval.filterAction': 'İşlem türü',
  'approval.filterAge': 'Yaş',
  'approval.age.1h': 'Son 1 saat',
  'approval.age.24h': 'Son 24 saat',
  'approval.age.7d': 'Son 7 gün',
  'approval.age.older': '7 günden eski',
  'approval.selectPrompt': 'Karar vermek için bir istek seçin.',
  'approval.reviewerFindings': 'İnceleyen bulguları',
  'approval.modifications': 'Değiştirilmiş işlem',
  'approval.modificationsHint': 'Onaylanacak son biçimi yazın. Ajan tam olarak bunu çalıştırır.',
  'approval.clarificationQuestion': 'Sorunuz',
  'approval.delegateTo': 'Yönlendirilecek kullanıcı',
  'approval.rejectReason': 'Ret gerekçesi',
  'approval.decidedBy': 'Kararı veren',
  'approval.decidedAt': 'Karar zamanı',
  'approval.decideFailed': 'Karar kaydedilemedi.',
  'approval.noPreview': 'Önizleme yok.',
  'approval.expiresSoon': 'Yakında sona eriyor',
  'approval.reasonRequired': 'Bu karar için bir gerekçe yazmalısınız.',

  // ---- Organisation ----
  'org.owner': 'Sahip',
  'org.executiveSupervisor': 'Yürütme Süpervizörü',
  'org.projectDirectors': 'Proje Direktörleri',
  'org.functionalManagers': 'İşlev Yöneticileri',
  'org.specialists': 'Uzmanlar',
  'org.auditor': 'Denetçi',
  'org.chart': 'Şema',
  'org.template': 'Tanım',
  'org.instance': 'Çalışan örnek',
  'org.noInstances': 'Bu rolden çalışan örnek yok.',
  'org.instanceCount': '{count} çalışan örnek',
  'org.emptyRoles': 'Rol tanımı yok.',
  'org.emptyRolesHint': 'Roller organizasyonun iş tanımlarıdır; kurulum sırasında oluşturulur.',
  'org.autonomy': 'Özerklik',
  'org.maxRisk': 'En yüksek risk',
  'org.tools': 'Verilen araçlar',
  'org.reportsTo': 'Bağlı olduğu',
  'org.category': 'Kategori',
  'org.uncategorised': 'Kategorisiz',
  'org.categoryHint':
    'Şema rolleri kategoriye göre bantlar. Kimene’de sabit bir hiyerarşi yoktur; bir rolün üstü, yükseltme yoludur.',
  'org.escalation': 'Yükseltme yolu',
  'org.escalatesTo': 'Yükseltilir:',
  'org.allowedTools': 'İzin verilen araçlar',
  'org.deniedCount': '{count} yasaklı',

  // ---- Analytics ----
  'analytics.taskDuration': 'İş süresi',
  'analytics.providerFailures': 'Sağlayıcı hataları',
  'analytics.hostUtilisation': 'Sunucu kullanımı',
  'analytics.rolePerformance': 'Rol başarımı',
  'analytics.window': 'Zaman aralığı',
  'analytics.window.24h': '24 saat',
  'analytics.window.7d': '7 gün',
  'analytics.window.30d': '30 gün',
  'analytics.window.90d': '90 gün',
  'analytics.noCost': 'Parasal maliyet gösterilmiyor',
  'analytics.noCostHint':
    'Sağlayıcı faturalandırması Kimene’ye açık değil. Uydurulmuş bir rakam, hiç rakam olmamasından kötüdür.',
  'analytics.empty': 'Henüz ölçülecek bir şey olmadı.',
  'analytics.emptyHint': 'İşler tamamlandıkça bu ekran dolar.',
  'analytics.completedTasks': 'Tamamlanan iş',
  'analytics.perDay': 'gün başına',

  // ---- Analytics: /analytics/summary'in gerçekten gönderdikleri ----
  // Yukarıdaki başlıkların çoğu, sunucunun hiç göndermediği rakamlara ait.
  // Aşağıdakiler yanıttaki alanların birebir karşılığı.
  'analytics.asOf': 'Şu ana göre',
  'analytics.noWindow': 'Bu ekran bir anlık görüntüdür',
  'analytics.noWindowHint':
    'Sunucu bu sayıları istek anında sayar; bir zaman aralığı uygulanmaz. “3 başarısız”, bu hafta üç kez değil, şu anda üç iş demektir.',
  'analytics.unqualified': 'Örnek sayısı bildirilmedi',
  'analytics.source.liveCount': 'canlı kayıt sayımı',
  'analytics.source.decisions': 'son yönlendirme kararları',

  'analytics.tasks': 'İşler',
  'analytics.tasksActive': 'Yürütülüyor',
  'analytics.tasksBlocked': 'Engellenmiş',
  'analytics.tasksNeedsHuman': 'İnsan bekliyor',
  'analytics.tasksFailed': 'Başarısız',

  'analytics.accounts': 'Hesap havuzu',
  'analytics.accountsTotal': 'Toplam hesap',
  'analytics.accountsReady': 'İş alabilir',
  'analytics.accountsAuthRequired': 'Oturum açılmalı',
  'analytics.accountsExhausted': 'Kotası dolmuş',
  'analytics.accountsDisabled': 'Kapalı',
  'analytics.accountsUnclassified': 'Sınıflandırılmamış',
  'analytics.accountsHint':
    'Sunucu yalnızca bu dört durumu sayar; yapılandırılmamış ya da bozulmuş hesaplar hiçbirine girmez ve “sınıflandırılmamış” olarak gösterilir.',

  'analytics.hosts': 'Sunucular',
  'analytics.hostsTotal': 'Toplam sunucu',
  'analytics.hostsOnline': 'Çevrimiçi',
  'analytics.hostsOffline': 'Çevrimdışı',
  'analytics.hostsUnclassified': 'Sınıflandırılmamış',

  'analytics.routing': 'Yönlendirme',
  'analytics.decisions': 'Karar sayısı',
  'analytics.unrouted': 'Yönlendirilemedi',
  'analytics.routedShare': 'Yönlendirilen oran',
  'analytics.meanDecisionTime': 'Ortalama karar süresi',
  'analytics.providerMix': 'Sağlayıcı dağılımı',
  'analytics.noProviderMix':
    'Hiçbir karar bir sağlayıcı seçemedi, dolayısıyla gösterilecek dağılım yok.',
  'analytics.simulatedExcluded':
    'Benzetim kararları sayılmaz; sayılsaydı bir arayüz yenilemesi operatörün baktığı rakamı oynatabilirdi.',

  'analytics.approvals': 'Onaylar',
  'analytics.approvalsOpen': 'Bekleyen onay',

  // ---- Audit ----
  'audit.empty': 'Denetim kaydı boş.',
  'audit.emptyHint': 'Her yönetsel işlem buraya yazılır. Henüz hiçbiri yapılmadı.',
  'audit.immutable': 'Bu kayıt yalnızca eklenir; hiçbir satır değiştirilemez ya da silinemez.',
  'audit.result.SUCCESS': 'Başarılı',
  'audit.result.FAILURE': 'Başarısız',
  'audit.result.DENIED': 'Reddedildi',
  'audit.clientIp': 'İstemci adresi',
  'audit.targetType': 'Hedef türü',
  'audit.exactMatch': 'Tam eşleşme aranır; parça eşleşmez.',
  'audit.actorPlaceholder': 'user:koraykaradas',
  'audit.actionPlaceholder': 'auth.login',
  'audit.targetTypePlaceholder': 'host',
  'audit.pageStatus': 'Sayfa {page} · {count} kayıt',
  'audit.page': 'Sayfa {page}',
  'audit.perPage': 'Sayfa başına satır',
  'audit.perPageOption': '{count} / sayfa',

  // ---- Settings ----
  'settings.keyCount': '{count} anahtar',
  'settings.saved': 'Kaydedildi.',
  'settings.unsaved': 'Kaydedilmedi',
  'settings.changed': 'değişti',
  'settings.revert': 'Geri al',

  // A document the server stores but nothing in this build reads. Said plainly:
  // a form that hides it invites an operator to set a policy, watch it save,
  // and believe it is in force.
  'settings.storedOnly': 'okuyan yok',
  'settings.storedOnlyHint':
    'Bu belge saklanıyor, sürümleniyor ve denetleniyor; ama bu sürümde onu okuyan bir bileşen yok. Buradan yapılan değişiklik bugün hiçbir davranışı değiştirmez — yürürlükte olan, koda gömülü varsayılan.',
  'settings.rewritten':
    'Bu ayarı bu ekran açıkken başka biri kaydetti. Form sunucudaki yeni değere göre yenilendi; kaydetmediğiniz değişiklikler varsa bunlar korunmadı — aksi hâlde diğer kaydın üzerine sessizce yazılırdı.',
  'settings.totp': 'İki adımlı doğrulama',
  'settings.totpOn': 'Açık',
  'settings.totpOff': 'Kapalı',
  'settings.revoke': 'Oturumu kapat',
  'settings.revokeOthers': 'Diğer tüm oturumları kapat',
  'settings.currentSession': 'Bu oturum',
  'settings.lastActive': 'Son etkinlik',
  // Routing — one relative weight per scoring component.
  'settings.routingLede':
    'Yönlendirme puanının her bileşeninin göreli ağırlığı. Ağırlıklar her kararla birlikte kaydedilir, böylece geçmiş kararlar açıklanabilir kalır.',
  'settings.routingInert':
    'Yönlendirici bugün kendi gömülü tablosundan puanlıyor; oradaki bileşen adları bu belgedekilerle birebir örtüşmüyor.',
  'settings.weightSum': 'Toplam',
  'settings.weightShare': 'Pay',
  'settings.weightShareHint':
    'Ağırlıklar görelidir; kararı belirleyen, her birinin toplam içindeki payı.',
  'settings.normalize': 'Toplamı 1,00’e ölçekle',
  'settings.weightAccountPreference': 'Hesap tercihi',
  'settings.weightCapacityHeadroom': 'Kapasite payı',
  'settings.weightHistoricalSuccess': 'Geçmiş başarı',
  'settings.weightHostLocality': 'Sunucu yakınlığı',
  'settings.weightLatency': 'Gecikme',
  'settings.weightModelSuitability': 'Model uygunluğu',
  'settings.weightReviewerDiversity': 'İnceleyici çeşitliliği',
  'settings.weightSessionContinuity': 'Oturum sürekliliği',

  // The chief's designation (ADR-0021, ADR-0025) — whose subscription Kimene's
  // own judgement is spent on. It is the first section because it is the one
  // that changes what the board is worth.
  'settings.chief': 'Şef',
  'settings.chiefLede':
    'Kimene’nin kendi kararlarını hangi aboneliğin ödediği. Panodaki “sıradaki adım” seçenekleri bu hesapta üretilir; hiçbir hesap seçilmemişse her oturum kendi hesabında analiz edilir — dürüst ama dar bir bakış, çünkü yargılayan hesap yargılananın ta kendisidir.',
  'settings.chiefAccount': 'Şef hesabı',
  'settings.chiefAccountHint':
    'Bir hesap seçmek onu harcama iznidir. Kredi yalnızca siz panoda “sıradaki adımı öner” dediğinizde harcanır. Hesabın kimlik dizini kontrol sunucusundan erişilebilir olmalı.',
  'settings.chiefAccountNone': 'Seçilmedi — her oturum kendi hesabında analiz edilir',
  'settings.chiefAccountGone': 'Kayıtlı hesap artık yok',
  'settings.chiefAccountOff': 'kapalı',
  'settings.chiefModel': 'Model',
  'settings.chiefModelHint': 'Boş bırakılırsa CLI kendi varsayılanını kullanır.',
  'settings.chiefModelDefault': 'CLI varsayılanı',
  'settings.chiefPortfolio': 'Portföy kararları',
  'settings.chiefPortfolioHint':
    'Şef bütün görevleri tek turda okuyup ne yapılması gerektiğine karar verir; panodaki “Şefin kararları” bölümü buna bağlıdır. Sıradaki adım seçenekleri buna bağlı değildir — hesabı seçmek onlar için yeter.',
  'settings.chiefPortfolioOn': 'Açık',
  'settings.chiefNeedsAccount': 'Portföy kararlarını açmadan önce bir şef hesabı seçin.',
  'settings.chiefLoopOn':
    'Şef, {minutes} dakikada bir kendiliğinden karar veriyor. Bu ekranda zamanlayıcı için alan yok; durdurmak için kayıttaki autonomousEveryMinutes değerini sıfırlayın.',

  // Retention — one window per class of history.
  'settings.retentionLede': 'Her geçmiş sınıfının kaç gün saklanacağı.',
  'settings.retentionEvents': 'Olaylar',
  'settings.retentionEventsHint': 'Yeniden bağlanan istemcilerin oynattığı alan olayı arşivi.',
  'settings.retentionRecordings': 'Oturum kayıtları',
  'settings.retentionRecordingsHint':
    'Ham uçbirim kayıtları — Kimene’nin sakladığı en yer kaplayan sınıf.',
  'settings.retentionAudit': 'Denetim kaydı',
  'settings.retentionAuditHint':
    '“Bunu kim yaptı, yetkisi var mıydı?” — yıllar sonra sorulabilecek soru.',
  'settings.retentionAuditNever': 'Hiç silinmez',
  'settings.retentionKeepForever': 'Hiç silinmesin',
  'settings.retentionStores': 'saklanan değer: {value}',
  'settings.retentionInvalid': 'Tam gün sayısı yazın.',
  'settings.days': 'gün',
  'settings.notifyFailures': 'Başarısız işler',
  'settings.themeDark': 'Koyu',
  'settings.themeLight': 'Açık',
  'settings.termFont': 'Terminal yazı boyu',
  'settings.termFontHint':
    'Panel için okunabilirlik tabanı buna göre ölçeklenir: büyük yazı, döşemeye daha geniş bir alt sınır demektir.',
  'settings.termFontSmall': 'Küçük',
  'settings.termFontNormal': 'Normal',
  'settings.termFontLarge': 'Büyük',
  'settings.density': 'Yoğunluk',
  // "Sıkı" and "Sıkışık" could not be told apart at a glance — two rungs of one
  // ladder, one letter between them. The middle rung is the default, which is
  // what an operator means by "normal", so that is what it is called now. Only
  // the label moved: the stored value is still `compact`, so nobody's preference
  // was rewritten by the rename.
  'settings.densityTight': 'Sıkı',
  'settings.densityCompact': 'Normal',
  'settings.densityComfortable': 'Rahat',
  'settings.densityHint':
    'Sıkı kademe, çerçeve boşluklarını tamamen kapatır: döşemeler tek çizgi kenarlıkla birleşir, tablolar sütun çizgisi kazanır.',
  'settings.appearanceLocal':
    'Bu tercihler yalnızca bu tarayıcıda saklanır; sunucuya yazılmaz, başka bir makinede geçerli olmaz. Seçim anında uygulanır, kaydetmek gerekmez.',

  // Autonomy — the six classes of consequential action, and the three answers
  // domain.AutonomyPolicy allows for each.
  'settings.autonomyLede':
    'Sonuç doğuran her işlem sınıfında Kimene’nin insansız davranıp davranamayacağı.',
  'settings.autonomyIsolatedWrites': 'Yalıtılmış yazmalar',
  'settings.autonomyIsolatedWritesHint':
    'Ajanın yalnızca kendi çalışma kopyasına yazması; kimsenin gördüğü bir dal değişmez.',
  'settings.autonomyMainMerge': 'Ana dala birleştirme',
  'settings.autonomyMainMergeHint': 'İşin herkesin çalıştığı dala geçmesi.',
  'settings.autonomyProductionDeploy': 'Canlıya çıkma',
  'settings.autonomyProductionDeployHint': 'Değişikliğin canlı ortamda yayına alınması.',
  'settings.autonomyDestructiveAction': 'Geri alınamaz işlem',
  'settings.autonomyDestructiveActionHint':
    'Silme, sıfırlama, zorlamalı yazma — sonrasında geri dönüşü olmayan işlemler.',
  'settings.autonomyExternalPublish': 'Dışarıya yayımlama',
  'settings.autonomyExternalPublishHint':
    'İçeriğin Kimene dışına çıkması. Dışarı çıkan şey silinse bile kopyalanmış olabilir.',
  'settings.autonomyFinancialSpend': 'Harcama',
  'settings.autonomyFinancialSpendHint': 'Para harcayan çağrılar ve kaynak açılışları.',
  'settings.decisionAutonomous': 'Kendi başına',
  'settings.decisionRequireApproval': 'Onay ister',
  'settings.decisionForbidden': 'Yasak',
  'settings.decisionUnknown': 'tanınmayan değer',

  'settings.missingKey': '“{key}” ayarı sunucuda yok.',
  'settings.missingKeyHint':
    'Bu anahtar kurulum tohumlamasında yazılır. Yoksa şu an gömülü varsayılan yürürlüktedir; burada oluşturmak, hiç seçilmemiş bir değeri seçilmiş gibi göstermek olurdu.',
  'settings.updatedByAt': '{who} · {when}',
  'settings.noWeights': 'Bu ayarda sayısal ağırlık yok.',
  'settings.noWeightsHint':
    'Sunucudaki değer beklenen biçimde değil. Düzeltilene kadar buradan düzenlenemez.',

  'settings.totpVerified': 'Bu oturumda doğrulandı',
  'settings.totpNotVerified': 'Bu oturumda doğrulanmadı',
  'settings.totpHint':
    'İkinci etken hesabın tamamı için geçerlidir; her oturumda ayrı ayrı açılmaz.',
  'settings.totpEnrol': 'İkinci etkeni kur',
  'settings.totpEnrolHint':
    'Gizli anahtarı doğrulayıcı uygulamanıza ekleyin, sonra ürettiği kodu yazın. Kod doğrulanmadan ikinci etken açılmaz.',
  'settings.totpSecret': 'Gizli anahtar',
  'settings.totpUrl': 'Kurulum adresi',
  'settings.totpParams': '{digits} hane · {period} saniye',
  'settings.totpCode': 'Doğrulama kodu',
  'settings.totpActivate': 'Doğrula ve aç',
  'settings.totpRecovery': 'Kurtarma kodları',
  'settings.totpRecoveryHint':
    'Bu kodlar bir kez gösterilir ve her biri bir kez kullanılır. Şimdi güvenli bir yere alın.',
  'settings.totpDisable': 'İkinci etkeni kaldır',
  'settings.totpDisableHint':
    'Kaldırmak için parolanız gerekir; ödünç alınmış bir oturum tek başına bu korumayı sökemesin diye.',

  // ---- Onaylarda ikinci etken (ADR-0032) ----
  'settings.approvalMfa': 'Onaylarda ikinci etken',
  'settings.approvalMfaLede':
    'Yüksek riskli bir kararı yalnızca ikinci etkenini sunmuş bir oturum verebilsin.',
  'settings.approvalMfaRequire': 'L3 ve L4 kararları',
  'settings.approvalMfaRequireHint':
    'Ana dala birleştirme, üretime çıkış, dışarıya yayın, parayla veya güvenlikle ilgili her şey. L1 ve L2 kapsam dışı: hepsini kapıya almak riski taşımadan sabrı harcar.',
  'settings.approvalMfaRequireOn': 'İkinci etken iste',
  'settings.approvalMfaNeedsEnrolment':
    'Önce yukarıdan bir ikinci etken kurun. Bu oturum etken sunmadığı için şimdi açmak, yüksek riskli bir onayı verebilecek kimse bırakmazdı.',
  'settings.approvalMfaNeedsSignIn':
    'İkinci etkeniniz kurulu ama bu oturum onu sunmadı. Çıkıp kodla yeniden girin; etken sunmamış bir oturumdan açmak, yüksek riskli bir onayı verebilecek kimse bırakmazdı.',

  'settings.sessionExpires': 'Bitiş',
  'settings.sessionIdle': 'işlemsiz: {when}',
  'settings.sessionRevoked': 'Kapatılmış',
  'settings.sessionRemembered': 'Açık tutuluyor',

  // ---- Bu kurulum: sunucunun kendisi hakkında bildirdikleri ----
  'system.deployment': 'Bu kurulum',
  'system.deploymentHint':
    'Sunucunun kendisi hakkında bildirdikleri. Hiçbiri buradan değiştirilemez; ne olduğunu değil, ne kurulu olduğunu anlatır.',
  'system.buildVersion': 'Sürüm',
  'system.buildCommit': 'Commit',
  'system.environment': 'Ortam',
  'system.timezone': 'Sunucu saat dilimi',
  'system.serverTime': 'Sunucu saati',
  'system.capabilities': 'Bu yapı neler yapabiliyor',
  'system.cap.realtimeEvents': 'Canlı olay akışı',
  'system.cap.terminalGateway': 'Terminal geçidi',
  'system.cap.idempotentWrite': 'Yinelemeye dayanıklı yazma',
  'system.cap.transactionalOutbox': 'İşlemsel olay kutusu',
  'system.cap.webBundle': 'Gömülü arayüz',
  'system.cap.on': 'var',
  'system.cap.off': 'yok',
  // Bir kurtarma yordamı farkı, dipnot değil: işlemsel olmayan bir olay
  // kutusunda teslim "en az bir kez"dir, yani yinelenen kayıt beklenir.
  'system.outboxIdempotent':
    'Veritabanı işlem desteklemiyor; olay kutusu bekleyen kayıtları yeniden yayımlar. Teslim en az bir kez olur — tüketiciler yinelemeye dayanıklı olmak zorunda.',

  'settings.otherHint':
    'Bu anahtarların özel bir düzenleyicisi yok. Sunucu değeri doğrulamadan sakladığı için burada yalnızca okunur.',
  'settings.readOnly': 'salt okunur',
  'settings.serverText': 'Sunucunun açıklaması',
  'settings.copyValue': 'Değeri kopyala',
  'settings.noOtherKeys': 'Başka ayar yok.',
  'settings.noOtherKeysHint': 'Sunucu şu an yalnızca düzenleyicisi olan anahtarları tutuyor.',

  // ---- Artifacts ----
  'artifact.title': 'Çıktılar',
  'artifact.subtitle': 'Ajanların ürettiği belgeler, yamalar ve raporlar',
  'artifact.reviewState': 'İnceleme durumu',
  'artifact.qualityScore': 'Kalite puanı',
  'artifact.versionChain': 'Sürüm zinciri',
  'artifact.contentHash': 'İçerik özeti',
  'artifact.preview': 'Önizleme',
  'artifact.previewUnavailable': 'Bu tür için metin önizlemesi yok.',
  'artifact.empty': 'Çıktı yok.',
  'artifact.emptyHint': 'İşler tamamlandıkça ürettikleri buraya düşer.',
  'artifact.size': 'Boyut',
  'artifact.supersedes': 'Yerine geçtiği',
  'artifact.currentVersion': 'Geçerli sürüm',
  'artifact.review.PENDING': 'Bekliyor',
  'artifact.review.APPROVED': 'Kabul edildi',
  'artifact.review.REJECTED': 'Reddedildi',
  'artifact.review.WAIVED': 'Muaf tutuldu',

  // Scoping. The listing endpoint refuses an unscoped request, so the reason is
  // interface copy rather than an error box.
  'artifact.scope': 'Kapsam',
  'artifact.chooseProject': 'Proje seçin…',
  'artifact.projectsUnavailable': 'Proje listesi alınamadı.',
  'artifact.scopeRequired': 'Önce bir proje seçin.',
  'artifact.scopeRequiredHint':
    'Sunucu kapsamsız çıktı listesini vermiyor: çıktı koleksiyonu sistemdeki en büyük koleksiyon ve filtresiz dökümü kimsenin okumadığı bir sayfa üretir.',
  'artifact.taskScope': 'Bu liste {taskId} işiyle sınırlı.',
  'artifact.clearScope': 'Kapsamı kaldır',
  'artifact.noProjects': 'Henüz proje yok.',
  'artifact.noProjectsHint':
    'Çıktılar bir projeye ya da işe bağlı olarak listelenir. Önce Projeler ekranından bir proje oluşturun.',

  'artifact.mission': 'Görev',
  'artifact.session': 'Oturum',
  'artifact.recordVersion': 'Kayıt sürümü',
  'artifact.provenance': 'Üretim izi',
  'artifact.provider': 'Sağlayıcı',
  'artifact.account': 'Hesap profili',
  'artifact.model': 'Model',
  'artifact.agent': 'Ajan örneği',

  'artifact.chainUnavailable':
    'Sunucu yalnızca bir önceki sürümün kimliğini veriyor; zincirin tamamını dolaşan bir uç nokta yok.',
  'artifact.noPrevious': 'Bu ilk sürüm.',
  'artifact.sources': 'Kaynaklar',
  'artifact.reviews': 'İncelemeler',
  'artifact.noReviews': 'Bu çıktı henüz incelenmedi.',
  'artifact.reviewer': 'İnceleyen',

  'artifact.download': 'Gövdeyi indir',
  'artifact.previewNoBody': 'Bu kaydın saklanan bir gövdesi yok.',
  'artifact.previewBinary': '{mime} türü metin olarak gösterilmiyor. Gövdeyi indirebilirsiniz.',
  'artifact.previewTooLarge':
    'Önizleme için fazla büyük ({size}). Sayfayı kilitlememek için gösterilmiyor; gövdeyi indirin.',
  'artifact.previewEmpty': 'Gövde boş.',

  // ---- Tools ----
  'tool.title': 'Araç Kayıt Defteri',
  'tool.subtitle': 'Ajanların çağırabildiği her araç ve taşıyan roller',
  'tool.key': 'Anahtar',
  'tool.destructive': 'Yıkıcı',
  'tool.approvalRequired': 'Onay gerektirir',
  'tool.roles': 'Taşıyan roller',
  'tool.noRoles': 'Hiçbir rol bu aracı taşımıyor.',
  // Rol kayıt defteri okunamadığında sütun boş kalmaz; "hiçbir rol taşımıyor"
  // demek, bilinmeyeni bilgiye çevirmek olurdu.
  'tool.rolesUnavailable': 'Rol kayıt defteri okunamadı; bu sütun doldurulamıyor.',
  'tool.empty': 'Kayıtlı araç yok.',
  'tool.emptyHint': 'Araç kayıt defteri sunucu tarafında doldurulur.',

  // ---- Agents ----
  'agent.title': 'Ajan Örnekleri',
  'agent.subtitle': 'Şu an çalışan rol örnekleri',
  'agent.currentRoute': 'Geçerli rota',
  'agent.routeHistory': 'Rota geçmişi',
  'agent.empty': 'Çalışan ajan yok.',
  'agent.emptyHint': 'Bir iş rotalandığında ajan örneği oluşur.',
  'agent.startedAt': 'Başlangıç',
  'agent.currentTask': 'Geçerli iş',
  'agent.noHistory': 'Rota değişikliği olmadı.',
  'agent.routeHistoryIds':
    'Rota geçmişi yalnızca kimlik olarak veriliyor; kimliği hesap, model ve sunucu adına çeviren bir uç nokta yok.',
  'agent.noRouteDetail': 'Geçerli rota yalnızca kimlik olarak biliniyor.',
  'agent.instanceName': 'Örnek adı',

  // ---- Sunucunun sağlamadığı bilgiler ----
  //
  // Bu metinler bir eksikliği açıkça söylemek için var. Uydurulmuş bir sayı ya
  // da sessizce boş kalan bir alan, operatöre "ölçüldü ve sıfır" der; bu ise
  // "ölçülmedi" der. Aradaki fark, bir kararı doğru ya da yanlış yapan şeydir.
  'project.configInventoryUnavailable': 'Dosya dökümü sunulmuyor',
  'project.configInventoryHint':
    'API bu proje için dosya listesi vermiyor; yalnızca yapılandırma parmak izini ve son tarama zamanını bildiriyor. Aşağıdaki beş yol Kimene’nin aradığı yerlerdir — varlıkları burada okunamaz.',
  'project.performanceUnavailable':
    'API bir proje için model başarım özeti üretmiyor. Sistem geneli sayılar Çözümleme ekranında, rota gerekçeleri Kararlar sekmesinde.',
  'project.sessionsScopeNote':
    'Sunucu oturumları projeye göre süzmüyor. Bu liste açık oturumlardan bu projeye ait olanlardır.',
  'project.taskScopeNote':
    'Sunucuda projeye göre iş listesi yok; işler görev görev toplanıyor. Bu sekmede yalnızca listelenen görevlerin işleri var.',
  'common.truncated': 'Liste kırpıldı; sayı en az bu kadar.',
  'task.evidenceRequirements': 'Kanıt gereksinimleri',
  'task.evidenceNone': 'Ek kanıt istenmiyor',
  'task.notStarted': 'Başlamadı',
  'mission.criticalPathComputed':
    'Kritik yol tarayıcıda bağımlılıklardan hesaplandı; sunucu böyle bir alan bildirmiyor.',
  'approval.noActions': 'Bu istek için yapılabilecek bir işlem kalmadı.',
  'approval.cancelRequest': 'İsteği iptal et',
  'approval.cancelRequestHint':
    'Bu, onay isteğini kapatır. İşin kendisini iptal etmek ayrı bir işlemdir ve iş ekranından yapılır.',
  'approval.answerClarification': 'Açıklamayı yanıtla',
  'approval.note': 'Not',

  // ---- Authentication ----
  'auth.secondFactor': 'İki adımlı doğrulama',
  'auth.totpHint': 'Doğrulayıcı uygulamanızdaki altı haneli kodu girin.',
  'auth.useRecoveryCode': 'Kurtarma kodu kullan',
  'auth.useAuthenticator': 'Doğrulayıcı koduna dön',
  'auth.recoveryCode': 'Kurtarma kodu',
  'auth.recoveryCodeHint':
    'Doğrulayıcınıza erişemiyorsanız tek kullanımlık kurtarma kodlarınızdan birini girin.',
  'auth.recoveryRequired': 'Kurtarma kodu gerekli.',
  'auth.recoveryInvalid': 'Kurtarma kodu hatalı ya da daha önce kullanılmış.',
  'auth.rememberMe': 'Oturumu açık tut',
  'auth.rememberMeHint':
    'Bu tarayıcıda oturum, uzun süre dokunmasanız bile açık kalır. Ortak bir bilgisayarda işaretlemeyin.',
  'auth.signingIn': 'Giriş yapılıyor',
  'auth.usernameRequired': 'Kullanıcı adı gerekli.',
  'auth.passwordRequired': 'Parola gerekli.',
  'auth.totpRequired': 'Bu hesap doğrulama kodu istiyor.',
  'auth.totpIncomplete': 'Kodun altı hanesini de girin.',
  'auth.totpInvalid': 'Doğrulama kodu hatalı.',
  'auth.serverNote': 'Kimene kendi sunucunuzda çalışır; bu form hiçbir dış servise veri göndermez.',

  // ---- Setup wizard ----
  'setup.stepOf': 'Adım {current} / {total}',
  'setup.finish': 'Kurulumu tamamla',
  'setup.skip': 'Bu adımı atla',
  'setup.dependenciesHint': 'Bu denetimler canlıdır; bu ekranda beklerken yenilenir.',
  'setup.controlHostHint': 'Kimene’nin üzerinde çalıştığı sunucu. Yerel yürütme buradan yapılır.',
  'setup.hostsHint':
    'Şimdi eklemek zorunda değilsiniz; sonradan Sunucular ekranından ekleyebilirsiniz.',
  'setup.nodeHint': 'Ajan, sunucuda oturumları yönetir ve ölçümleri geri gönderir.',
  'setup.accountsHint': 'Sağlayıcı oturumu sunucuda açılır; kimlik bilgileri tarayıcıya gelmez.',
  'setup.projectsHint': 'Bir proje, bir ya da daha çok depoyu ve onların kalite kapılarını toplar.',
  'setup.routingHint': 'Bu varsayılanlar proje bazında geçersiz kılınabilir.',
  'setup.orchestratorHint': 'Orkestratörün ne kadar kendi başına karar alacağını belirler.',
  'setup.finalCheckHint': 'Her şeyi son bir kez gözden geçirin. Bundan sonra konsol açılır.',
  'setup.passwordMismatch': 'Parolalar eşleşmiyor.',
  'setup.passwordTooShort': 'Parola en az 12 karakter olmalı.',
  'setup.confirmPassword': 'Parola (yeniden)',
  'setup.ownerCreated': 'Yönetici hesabı oluşturuldu.',
  'setup.stepFailed': 'Bu adım tamamlanamadı.',
  'setup.blockedByHealth': 'Zorunlu bir bağımlılık başarısız. Devam etmeden önce düzeltin.',
  'setup.dependencyDetailHidden':
    'Bağımlılık ayrıntısı yalnızca oturum açmış kullanıcılara gösterilir; altyapı topolojisi kimliği doğrulanmamış isteklere sızdırılmaz. Genel durum aşağıda; ayrıntı için kurulumu tamamlayıp giriş yapın.',
  'cc.dependencyDetailHidden': 'Bağımlılık ayrıntısı bu oturumda gösterilmiyor.',
  'setup.nothingYet': 'Henüz kayıt yok — bu adımı sonraya bırakabilirsiniz.',

  // ---- Not found ----
  'notfound.title': 'Böyle bir sayfa yok',
  'notfound.hint': 'Adres yanlış olabilir ya da kayıt kaldırılmış olabilir.',
  'notfound.home': 'Komuta Merkezi’ne dön',

  // ---- System risks ----
  //
  // Keyed by the server's risk `kind`, filled from its `params`. The server
  // also sends a composed English title and detail; those are the fallback for
  // a kind added after this table, so a new detector still says something.
  'risk.no_eligible_account': 'Hiçbir hesap iş kabul edemiyor',
  'risk.no_eligible_account.detail':
    'Tüm profiller devre dışı, yapılandırılmamış, kotası dolmuş ya da oturum açılmayı bekliyor. Biri toparlanana kadar hiçbir iş yönlendirilmeyecek.',
  'risk.account_auth_required': '{account} hesabı için oturum açılması gerekiyor',
  'risk.account_auth_required.detail':
    'Kimlik bilgileri sunucuya özel; {host} üzerindeki bir terminalden oturum açın.',
  'risk.account_exhausted': '{account} hesabı doğrulanmış bir kota sınırına takıldı',
  'risk.host_offline': '{host} sunucusu {status} durumunda',
  'risk.host_offline.detail': 'Bu sunucuya iş yönlendirilemez ve üzerindeki oturumlara erişilemez.',
  'risk.host_stale': '{host} sunucusu bir süredir bildirim göndermiyor',
  'risk.host_stale.detail':
    'Telemetrisi {age} değerinden eski; ölçümlerini güncel değil, bilinmiyor olarak değerlendirin.',
  'risk.approval_waiting': 'Onay bekliyor: {title}',
  'risk.approval_overdue': 'Onay gecikti: {title}',
  'risk.approval_overdue.detail': 'Bir gündür karar bekliyor. Hiçbir şey onu iptal etmez; kararı sen verirsin.',
  'risk.dependency_down': '{dependency} erişilemiyor',
  'severity.critical': 'kritik',
  'severity.error': 'hata',
  'severity.warning': 'uyarı',
  'severity.info': 'bilgi',
  // ---- Dashboard, last turn and the conductor's advice ----
  'nav.dashboard': 'Pano',
  'dashboard.title': 'Pano',
  'dashboard.count.calm': '{total} oturum',
  'dashboard.count.attention': '{total} oturum · {attention} ilgi bekliyor',
  'dashboard.search': 'Oturum ara',
  'dashboard.searchPlaceholder': 'ad, hesap, model, sunucu…',
  'dashboard.advice.title': 'Şefin önerileri',
  'dashboard.advice.calm': 'Şefin önerisi yok',
  'dashboard.advice.open': 'Aç',
  'dashboard.blind.title': 'Bekleme sinyali',
  'dashboard.blind.body': 'Bekleme sinyali çalışmıyor: {count} ajanın hiçbiri hiç rapor vermedi, "bekliyor" ölçülemiyor',
  'dashboard.risks.title': 'Riskler',
  'dashboard.posture.title': 'Havuz durumu',
  'dashboard.posture.accounts': 'hesap iş alabilir',
  'dashboard.posture.hosts': 'sunucu çevrimiçi',
  'dashboard.posture.degraded': 'bozuk',
  'dashboard.posture.day': 'son 24 saatte',
  'dashboard.posture.completed': 'tamamlandı',
  'dashboard.posture.failed': 'başarısız',
  'dashboard.advice.openTask': 'Görevi aç',
  'dashboard.sessions.empty': 'Listede oturum yok',
  'dashboard.sessions.emptyHint': 'Bir oturum başlatın; pano onu burada izler.',
  'dashboard.sessions.noMatch': 'Bu süzgeçle eşleşen oturum yok',
  'dashboard.sessions.showAll': 'Tümünü göster',
  'dashboard.now.title': 'Şimdi',
  'dashboard.fleet.title': 'Filo',
  'dashboard.fleet.working': '{count} çalışıyor',
  'dashboard.fleet.quiet': '{count} sessiz',
  'dashboard.fleet.ended': '{count} bitti',
  'dashboard.row.endedWhy': 'Oturumun bittiği an.',
  'dashboard.silence.for': '{duration} sessiz',
  'dashboard.posture.unattended': 'oturum izin sormadan çalışıyor',
  'dashboard.posture.unattendedWhy':
    'Bu oturumlar sağlayıcı CLI’sinin kendi izin sorularını atlayarak başlatıldı (bypassApprovals): yazmadan, komut çalıştırmadan önce durup sormazlar — ve sessizlikleri hiçbir zaman “izin bekliyor” olamaz.',
  'dashboard.silence.unmeasured': 'Ne kadar süredir sessiz olduğu ölçülmedi.',
  'dashboard.silence.from.done': 'Ajan turunu bitirdiğini bildirdi; o andan beri sessiz.',
  'dashboard.silence.from.waiting': 'Ajan bir insanı beklediğini bildirdi; o andan beri sessiz.',
  'dashboard.silence.from.busy': 'Terminalinde en son bu kadar önce çıktı üretti.',
  'dashboard.silence.from.transcript':
    'Ajanın kendi kaydından okundu — bu oturumun terminaline canlı bakış yok.',
  'session.lastTurn.title': 'Son tur',
  'session.lastTurn.prompt': 'İstek',
  'session.lastTurn.reply': 'Yanıt',
  'session.lastTurn.tool': 'Son araç',
  'session.lastTurn.toolFailed': 'hata verdi',
  'session.lastTurn.tools': '{calls} araç çağrısı',
  'session.lastTurn.toolErrors': '{errors} hata',
  'session.lastTurn.files': '{count} dosya',
  'session.lastTurn.lastLine': 'Son satır',
  'session.lastTurn.unmeasured': 'Kayıt okunamıyor: CLI kaydı yok ya da oturum bitti.',
  'session.lastTurn.turnOpen': 'turun başı pencerenin dışında; sayılar taban',
  'session.lastTurn.atLeast': 'en az',
  'advice.answer_waiting_session': '{session} {minutes} dakikadır seni bekliyor — yanıtla.',
  'advice.read_finished_turn': '{session} turunu {minutes} dakika önce bitirdi ve kimse okumadı — sonucu oku, sonraki adımı ver.',
  'advice.switch_session_account': '{session}, {reason} {fromAccount} hesabında çalışıyor — güvenli sınırda {toAccount} hesabına geçir.',
  'advice.session_account_blocked': '{session}, {reason} {fromAccount} hesabında çalışıyor; geçilecek uygun hesap yok — durdur, sıfırlanmayı bekle ya da giriş yap.',
  'advice.restart_failed_session': '{session} başarısız oldu — hatayı oku, yeniden başlat.',
  'advice.restart_failed_session.exit': '{session} başarısız oldu (çıkış {exit}) — hatayı oku, yeniden başlat.',
  'advice.check_quiet_session': '{session} {minutes} dakikadır sessiz — takıldı mı bitti mi bak; gerekmiyorsa durdur.',
  'advice.tool_errors_in_turn': '{session} son turunda {errors} araç hatası verdi — komutlara bak.',
  'advice.idle_capacity': '{count} hesap boşta ve kapasitesi var ({accounts}) — iş başlat.',
  'advice.reason.exhausted': 'tükenen',
  'advice.reason.auth_required': 'yeniden giriş isteyen',
  'advice.reason.disabled': 'devre dışı',

  // ---- Missions and tasks (M1) ----
  'work.title': 'Görevler',
  'work.subtitle': 'Bir görev bir amacı işlere böler; her iş kanıtla tamamlanır',
  'work.count.calm': '{missions} görev · {tasks} açık iş',
  'work.count.attention': '{missions} görev · {tasks} açık iş · {attention} seni bekliyor',
  'work.search': 'İş ara',
  'work.searchPlaceholder': 'başlık, amaç, görev…',
  'work.band.all': 'Tümü',
  'work.band.needsPerson': 'Seni bekliyor',
  'work.band.ready': 'Hazır',
  'work.band.running': 'Koşuyor',
  'work.band.failed': 'Başarısız',
  'work.band.other': 'Diğer',
  'work.task.moved': 'Son hareket',
  'work.task.noMatch': 'Bu süzgeçle eşleşen iş yok',
  'work.task.showAll': 'Tümünü göster',
  'work.missions': 'Görevler',
  'work.tasks': 'İşler',
  'work.allOpenTasks': 'Tüm açık işler',
  'work.createMission': 'Görev oluştur',
  'work.createTask': 'İş ekle',
  'work.mission.title': 'Başlık',
  'work.mission.objective': 'Amaç',
  'work.mission.project': 'Proje',
  'work.mission.priority': 'Öncelik (0–100)',
  'work.mission.risk': 'Risk düzeyi',
  'work.mission.acceptance': 'Kabul ölçütleri (her satır bir ölçüt)',
  'work.mission.counts': '{total} iş · {running} koşuyor · {needsHuman} seni bekliyor',
  'work.mission.none': 'Henüz görev yok',
  'work.mission.noneHint': 'Bir görev, bir amacı işlere bölen kaptır. İlkini oluşturun.',
  'work.mission.select': 'İşlerini görmek için bir görev seçin; seçim yoksa tüm açık işler listelenir.',
  'work.mission.selected': 'Seçili görev: {title}',
  'work.mission.clear': 'Seçimi kaldır',
  'work.mission.move': 'Durumu değiştir',
  'work.mission.completeBlocked': 'Bir görev ancak incelemeden ve her işi çözülmüşken tamamlanır.',
  'work.task.title': 'Başlık',
  'work.task.objective': 'Amaç',
  'work.task.archetype': 'İş türü',
  'work.task.priority': 'Öncelik (0–100)',
  'work.task.acceptance': 'Kabul ölçütleri (her satır bir ölçüt)',
  'work.task.dependsOn': 'Bağımlı olduğu işler',
  'work.task.none': 'Bu görevde henüz iş yok',
  'work.task.noneOpen': 'Açık iş yok',
  'work.task.noneHint': 'Bir iş, tek sorumluluğu ve açık kabul ölçütü olan bir birimdir. İlkini ekleyin.',
  'work.task.state': 'Durum',
  'work.task.session': 'Oturum',
  'work.task.noSession': 'Henüz bir oturuma bağlanmadı',
  'work.task.sessionEnded': 'oturum bitti',
  'work.task.attempts': '{count}/{max} deneme',
  'work.task.blocked': 'Engel: {reason}',
  'work.task.evidence': 'Kanıt sözleşmesi',
  'work.task.evidenceHint': 'Bu iş, kanıt sözleşmesi karşılanmadan tamamlanmış sayılmaz; sözleşme yalnız sıkılaştırılabilir.',
  'work.task.evidenceNone': 'Ek kanıt istenmiyor; yine de inceleme gerekir.',
  'work.task.evidence.tests': 'testler geçmeli',
  'work.task.evidence.build': 'derleme geçmeli',
  'work.task.evidence.lint': 'lint geçmeli',
  'work.task.evidence.diff': 'gerçek bir değişiklik',
  'work.task.evidence.reviewer': 'bağımsız inceleme',
  'work.task.evidence.sources': 'kaynak gösterimi',
  'work.task.evidence.screenshot': 'ekran görüntüsü',
  'work.task.evidence.approval': 'insan onayı',
  'work.evidence.title': 'Toplanan kanıt',
  'work.evidence.satisfied': 'Kanıt sözleşmeyi karşılıyor',
  'work.evidence.unsatisfied': 'Kanıt henüz sözleşmeyi karşılamıyor',
  'work.evidence.none': 'Henüz kanıt toplanmadı. İş incelemeye geçince fark, derleme, test ve lint toplanır.',
  'work.evidence.check.diff': 'değişiklik',
  'work.evidence.check.tests': 'testler',
  'work.evidence.check.build': 'derleme',
  'work.evidence.check.lint': 'lint',
  'work.evidence.check.forbiddenPaths': 'yasaklı yollar',
  'work.evidence.changedFiles': '{count} dosya',
  'work.evidence.superseded': 'eskidi',
  'work.route.title': 'Rota',
  'work.route.preview': 'Neden bu hesap?',
  'work.route.none': 'Uygun rota yok — aday hesaplar reddedildi.',
  'work.route.reject.ACCOUNT_DISABLED': 'hesap kapalı',
  'work.route.reject.ACCOUNT_CANNOT_ACCEPT_WORK': 'iş kabul edemez',
  'work.route.reject.ACCOUNT_NOT_REACHABLE_FROM_HOST': 'bu host\'tan erişilemez',
  'work.route.reject.MODEL_UNAVAILABLE_FOR_ACCOUNT': 'model bu hesapta yok',
  'work.route.reject.MODEL_BLOCKED': 'eşleşme engelli',
  'work.route.reject.HOST_OFFLINE': 'host çevrimdışı',
  'work.route.reject.PROVIDER_CLI_NOT_INSTALLED': 'CLI kurulu değil',
  'work.route.reject.REPOSITORY_NOT_AVAILABLE_ON_HOST': 'repo host\'ta yok',
  'work.route.reject.ACCOUNT_AT_CONCURRENCY_LIMIT': 'eşzamanlılık sınırında',
  'work.route.reject.SUBSCRIPTION_EXHAUSTED': 'aynı abonelik tükenmiş',
  'work.route.reject.BLOCKED_BY_PROJECT_POLICY': 'proje politikası engelliyor',
  'work.route.reject.PINNED_TO_A_DIFFERENT_ROUTE': 'başka rotaya sabitli',
  'work.task.dependencies': '{count} bağımlılık',
  'work.task.open': 'İşi aç',
  'work.task.startSession': 'Bu iş için oturum başlat',
  'work.task.nextStates': 'Olası sonraki durumlar',
  'work.task.actions': 'Kararlar',
  'work.task.created': 'İş eklendi',
  'work.decision.ready': 'Hazır işaretle',
  'work.decision.review': 'İncelemeye gönder',
  'work.decision.approve': 'Onayla',
  'work.decision.rework': 'Düzeltme iste',
  'work.decision.cancel': 'İptal et',
  'work.decision.retry': 'Yeniden dene',
  'work.decision.pause': 'Duraklat',
  'work.decision.resume': 'Sürdür',
  'work.decision.reason': 'Gerekçe (isteğe bağlı)',
  'work.decision.confirm': '{decision} — emin misiniz?',
  'work.startForTask': 'Bu oturum "{title}" işi için başlatılacak; iş RUNNING durumuna geçer ve oturumu gösterir.',
  'work.missionState.DRAFT': 'Taslak',
  'work.missionState.PLANNING': 'Planlanıyor',
  'work.missionState.ACTIVE': 'Etkin',
  'work.missionState.BLOCKED': 'Engelli',
  'work.missionState.PAUSED': 'Duraklatıldı',
  'work.missionState.REVIEWING': 'İnceleniyor',
  'work.missionState.COMPLETED': 'Tamamlandı',
  'work.missionState.CANCELLED': 'İptal edildi',
  'work.missionState.FAILED': 'Başarısız',
  'work.taskState.DRAFT': 'Taslak',
  'work.taskState.ANALYZING': 'Çözümleniyor',
  'work.taskState.PLANNED': 'Planlandı',
  'work.taskState.READY': 'Hazır',
  'work.taskState.QUEUED': 'Sırada',
  'work.taskState.ROUTING': 'Yönlendiriliyor',
  'work.taskState.LEASED': 'Kiralandı',
  'work.taskState.STARTING': 'Başlıyor',
  'work.taskState.RUNNING': 'Koşuyor',
  'work.taskState.WAITING_FOR_AGENT': 'Ajanı bekliyor',
  'work.taskState.WAITING_FOR_HUMAN': 'İnsanı bekliyor',
  'work.taskState.PAUSED': 'Duraklatıldı',
  'work.taskState.RATE_LIMITED': 'Hız sınırı',
  'work.taskState.AUTH_REQUIRED': 'Giriş gerekli',
  'work.taskState.HOST_UNREACHABLE': 'Sunucuya ulaşılamıyor',
  'work.taskState.HANDOFF_PENDING': 'Devir bekliyor',
  'work.taskState.POLICY_BLOCKED': 'Politika engeli',
  'work.taskState.FAILED_RETRYABLE': 'Başarısız (yeniden denenebilir)',
  'work.taskState.FAILED_FINAL': 'Başarısız',
  'work.taskState.REVIEWING': 'İnceleniyor',
  'work.taskState.REWORK_REQUIRED': 'Düzeltme gerekli',
  'work.taskState.APPROVAL_REQUIRED': 'Onay gerekli',
  'work.taskState.COMPLETED': 'Tamamlandı',
  'work.taskState.CANCELLED': 'İptal edildi',
  'work.archetype.planning': 'planlama',
  'work.archetype.architecture': 'mimari',
  'work.archetype.frontend': 'ön yüz',
  'work.archetype.backend': 'arka uç',
  'work.archetype.mobile': 'mobil',
  'work.archetype.database': 'veritabanı',
  'work.archetype.testing': 'test',
  'work.archetype.review': 'inceleme',
  'work.archetype.research': 'araştırma',
  'work.archetype.product': 'ürün',
  'work.archetype.design': 'tasarım',
  'work.archetype.marketing': 'pazarlama',
  'work.archetype.advertising': 'reklam',
  'work.archetype.content': 'içerik',
  'work.archetype.devops': 'devops',
  'work.archetype.security': 'güvenlik',
  'work.archetype.analytics': 'analitik',
  'advice.decide_on_task': '"{task}" işi {state} durumunda — kararın bekleniyor (onayla, düzeltme iste ya da iptal et).',
  'advice.start_ready_task': '"{task}" işi hazır ve üzerinde kimse çalışmıyor — bir oturum başlat.',
  'advice.task_session_ended': '"{task}" işi koşuyor görünüyor ama oturumu bitmiş — işi incelemeye gönder ya da yeni oturum başlat.',

  // ---- The conductor (M2a) ----
  'conductor.title': 'Şef',
  'conductor.run': 'Şefi çalıştır',
  'conductor.lede': 'Şef ne yapacağını planlar, sen onaylayınca uygular; kendiliğinden hiçbir şeye başlamaz.',
  'conductor.nothingToStart': 'Şu an başlatılacak hazır iş yok.',
  'conductor.starts': 'Başlatılacak ({count})',
  'conductor.reclaims': '{count} iş kuyruğa geri alınacak (oturumu bitmiş).',
  'conductor.deferred': '{count} iş şimdilik başlatılamıyor.',
  'conductor.approve': 'Onayla ve uygula',
  'conductor.approveConfirm': '{count} oturum başlatılacak ve şef istemleri gönderecek. Onaylıyor musun?',
  'conductor.applying': 'Uygulanıyor: {count}/{total} —',
  'conductor.history': 'Geçmiş çalıştırmalar',
  'conductor.runSummary': '{starts} başlatma',

  // ---- Approvals (M6, ADR-0024) ----
  'approvals.card': 'Bu iş senin kararını bekliyor',
  'approvals.rule.risk.l3-requires-approval': 'Geri alınamaz iş (L3)',
  'approvals.rule.risk.l4-requires-approval': 'Para veya güvenlik (L4)',
  'approvals.rule.evidence.human-approval-required': 'İş sözleşmesi insan onayı istiyor',
  'approvals.affects': 'Etkilenenler',
  'approvals.ifDenied': 'Reddedilirse',
  'approvals.requestedFor': '{actor} adına',
  'approvals.approve': 'Onayla ve tamamla',
  'approvals.reject': 'Reddet, yeniden çalışılsın',
  'approvals.note': 'Not (kayda geçer)',
  'approvals.decidedBy': '{actor} karar verdi',
  'approvals.mayNot':
    'Bu kararı sen veremezsin. Gereken izin: {permissions}. Bir işi başlatan kişi onu onaylayan kişi olmamalı.',
  'approvals.state.PENDING': 'Bekliyor',
  'approvals.state.APPROVED': 'Onaylandı',
  'approvals.state.REJECTED': 'Reddedildi',
  'approvals.state.CANCELLED': 'İptal edildi',

  // ---- The chief's decisions, across the workforce (M5, ADR-0021) ----
  'supervisor.title': 'Şefin kararları',
  'supervisor.decide': 'Şef karar versin',
  'supervisor.lede':
    'Şef bütün iş gücünü okur ve sırada ne olması gerektiğini gerekçesiyle önerir; hiçbir şey sen onaylamadan uygulanmaz.',
  'supervisor.runsOn': 'Karar turu şu hesapta harcanır:',
  'supervisor.deciding': 'Şef düşünüyor — bütün iş gücünü okuyup karar veriyor.',
  'supervisor.nothingToDo': 'Şef şu an yapılacak bir şey görmüyor. Bu da bir karardır.',
  'supervisor.actions': 'Önerilen adımlar ({count})',
  'supervisor.approve': 'Onayla ve uygula',
  'supervisor.approveConfirm':
    '{count} adım uygulanacak. Aradan geçen sürede değişen işler uygulanmaz, gerekçesiyle reddedilir. Onaylıyor musun?',
  'supervisor.history': 'Geçmiş kararlar',
  'supervisor.noSummary': 'Özet yok',
  'supervisor.repairs': '{count} düzeltme turu',
  'supervisor.kind.START_TASK': 'Başlat',
  'supervisor.kind.PAUSE_TASK': 'Duraklat',
  'supervisor.kind.RESUME_TASK': 'Sürdür',
  'supervisor.kind.SEND_TO_REVIEW': 'İncelemeye gönder',
  'supervisor.kind.REQUEST_REWORK': 'Yeniden çalışılsın',
  'supervisor.kind.REQUEST_REROUTE': 'Hesap değişsin',
  'supervisor.kind.ESCALATE_TO_HUMAN': 'Sana devret',
  'supervisor.outcome.APPLIED': 'Uygulandı',
  'supervisor.outcome.RECORDED': 'Kaydedildi',
  'supervisor.outcome.REFUSED': 'Reddedildi',
  'supervisor.outcome.FAILED': 'Başarısız',
  'supervisor.outcome.AWAITING_OPERATOR': 'Seni bekliyor',
  'supervisor.autonomous': 'kendiliğinden',
  'supervisor.loopOn': 'Şef her {minutes} dakikada bir karar veriyor; sadece işi durduran ve sana devreden adımları kendi uyguluyor.',

  // ---- The chief, per session (ADR-0017) ----
  'chief.next': 'Sıradaki adım',
  'chief.analyze': 'Sıradaki adımı öner',
  'chief.analyzeHint':
    'Şef; son turu, projenin deposunu ve dalını okuyup gönderilebilecek talimatları seçenek olarak sunar (bir istek harcar).',
  'chief.bymodel': 'modelden',
  'chief.nextPrompt': 'Gönderilecek prompt',
  'chief.nextPromptPlaceholder': 'Bu oturuma yazılacak metin…',
  'chief.send': 'Gönder',
  'chief.sent': 'Gönderildi',
  'chief.sendHint': '⌘/Ctrl + Enter ile gönder · Esc ile kapat',
  'chief.sendEmpty': 'Gönderilecek bir metin yok',
  'chief.finished': 'Şef bu işi tamamlanmış görüyor — incele ve gerekiyorsa oturumu durdur.',
  'chief.unavailable': 'Model analizi bu kurulumda çalıştırılamadı; deterministik öneri gösteriliyor.',
  'chief.action.CONTINUE': 'Sürdür',
  'chief.action.ANSWER': 'Yanıtla',
  'chief.action.FINISH': 'Bitti',
  'chief.action.HOLD': 'Bekle',

  // Why the chief proposed what it did. The server names the rule and its
  // values; the sentence is composed here, so a Turkish console never shows the
  // English one that used to arrive assembled (lib/chiefReason.ts).
  'chief.reason.session_ended': 'Oturum bitti; gönderilecek bir şey yok.',
  'chief.reason.agent_working': 'Ajan çalışıyor; bir sınıra gelmesini bekleyin.',
  'chief.reason.agent_waiting': 'Ajan sizi bekliyor ({reason}). Bölmeyi okuyup yanıtlayın.',
  'chief.reason.agent_waiting_plain': 'Ajan sizi bekliyor. Bölmeyi okuyup yanıtlayın.',
  'chief.reason.tool_errors': 'Son turda {errors} araç hatası var.',
  'chief.reason.turn_finished':
    'Ajan bir turu bitirdi; yaptığını gözden geçirip sürdürmesi ya da bittiğini doğrulaması öneriliyor.',
  'chief.reason.no_signal':
    'Oturum sessiz ve net bir işaret yok; sürdürmesini ya da bittiğini söylemesini isteyin.',
  'chief.reason.unstructured':
    'Analiz yapılandırılmış bir öneri döndürmedi; yazdığı metin sıradaki prompt olarak sunuluyor.',
  // Why the model could not be asked, so the rules answered instead.
  'chief.note.account_unreachable':
    'Hesap kontrol sunucusundan erişilemiyor, model analizi burada çalıştırılamadı.',
  'chief.note.no_transcript': 'Analiz edilecek okunabilir bir kayıt yok.',
  'chief.note.analysis_failed': 'Model analizi tamamlanamadı ({error}).',
  // ADR-0025: kararı hangi hesabın verdiği, ve veremediyse nedeni.
  'chief.note.no_manager':
    'Şef hesabı tayin edilmedi; analiz oturumun kendi hesabında çalıştı. Ayarlar → Şef\'ten bir hesap seçerek öneriler bütün filoyu tek bir gözden okusun.',
  'chief.note.manager_unusable':
    'Tayin edilen şef hesabı şu an kullanılamıyor; öneriler kurallardan geldi. Başka bir aboneliğe geçilmedi.',
  'chief.options': 'Seçenekler',
  'chief.runsOn': 'Şef',

  // ---- Dosyalar: host dosya yüzeyi (ADR-0026) ----
  // Arayüzde "Dosyalar", komut paletinde "FTP" ile bulunur. Gerçekte FTP değil:
  // her şey SSH kanalından geçer, ve yedi root oturumunun yanında "FTP" etiketi
  // bir denetçiyi yanlış yere alarma geçirir.
  'hostfiles.title': 'Dosyalar',
  'hostfiles.subtitle': '{host} · {roots} kayıtlı kök',
  'hostfiles.local': 'Yerel',
  'hostfiles.remote': 'Uzak',
  'hostfiles.colName': 'Ad',
  'hostfiles.colSize': 'Boyut',
  'hostfiles.colModified': 'Değiştirilme',
  'hostfiles.chooseFolder': 'Klasör seç',
  'hostfiles.changeFolder': 'Klasörü değiştir',
  'hostfiles.chooseFolderFirst': 'Henüz bir klasör seçilmedi',
  'hostfiles.chooseFolderHint':
    'Bir klasör seçin: soldaki panel gerçekten o dizini gezer, ve indirdikleriniz tarayıcının indirme klasörüne değil oraya iner.',
  'hostfiles.addFiles': 'Dosya ekle',
  'hostfiles.trayMode': 'Bu tarayıcı yerel klasör açamıyor — seçtikleriniz burada birikir',
  'hostfiles.emptyLocal': 'Bu klasör boş',
  'hostfiles.emptyRemote': 'Bu dizin boş',
  'hostfiles.send': 'Seçilenleri sunucuya gönder',
  'hostfiles.fetch': 'Seçilenleri buraya al',
  'hostfiles.localDenied': 'Klasöre yazma izni verilmedi.',
  'hostfiles.noRootsShort': 'Kök seçilmedi',
  'hostfiles.discardConfirm': 'Yarım kalmış yükleme atılsın mı? Gönderilen baytlar silinir.',
  'hostfiles.tabActive': 'Sürüyor',
  'hostfiles.tabFailed': 'Başarısız',
  'hostfiles.tabDone': 'Bitti',
  'hostfiles.clearFinished': 'Bitenleri temizle',
  'hostfiles.queueEmpty': 'Burada bir şey yok.',
  'hostfiles.root': 'Kök',
  'hostfiles.roots': 'Kayıtlı kökler',
  'hostfiles.manageRoots': 'Kökleri yönet',
  'hostfiles.noRoots': 'Kayıtlı kök yok',
  'hostfiles.noRootsHint':
    'Bir dosyaya ulaşmak için önce hangi dizine bakılacağının kaydedilmesi gerekir. Kayıt, sınırın kendisidir: kimlik bilgisi taşıyan bir dizin en baştan reddedilir.',
  'hostfiles.addRoot': 'Kök ekle',
  'hostfiles.rootHost': 'Sunucu',
  'hostfiles.rootPath': 'Mutlak yol',
  'hostfiles.rootPathHint': 'Örn. /opt/kimene, /var/log, /ssd/data/project/kimene',
  'hostfiles.rootLabel': 'Ad',
  'hostfiles.rootWritable': 'Yazılabilir',
  'hostfiles.rootWritableHint':
    'Kapalıysa buraya yükleme yapılamaz. Varsayılan kapalı: bir makineden alınacak şey, oraya bırakılacak şeyden çok daha sık.',
  'hostfiles.rootRemove': 'Kaydı geri çek',
  'hostfiles.refusedContains':
    'Bu dizin {what} içeriyor, o yüzden kaydedilemez. Daha dar bir dizin seçin — örneğin projelerin bulunduğu alt dizin.',
  'hostfiles.refusedInside':
    'Bu dizin {what} içinde. Daraltmak bunu çözmez; kökün başka bir yerde olması gerekir.',
  'hostfiles.holds.account': 'sağlayıcı hesap dizinleri',
  'hostfiles.holds.keys': 'sunucu SSH anahtarlarını',
  'hostfiles.holds.env': 'parola taşıyan ortam dosyalarını',
  'hostfiles.holds.ssh': 'SSH yapılandırmasını',
  'hostfiles.holds.state': 'Kimene’nin kendi durum dizinini',
  'hostfiles.rootRemoveConfirm':
    'Bu kök geri çekilsin mi? Buradan alınan dosyaların denetim kayıtları okunabilir kalır.',
  'hostfiles.readOnlyRoot': 'salt okunur',
  'hostfiles.pathBar': 'Yol',
  'hostfiles.pathBarHint': 'Mutlak bir yol yapıştırıp Enter’a basın; onu içeren kök seçilir.',
  'hostfiles.pathNotInAnyRoot': 'Bu yol kayıtlı köklerin hiçbirinin içinde değil.',
  'hostfiles.up': 'Üst dizin',
  'hostfiles.truncated': 'Bu dizin gösterilenden fazlasını tutuyor.',
  'hostfiles.denied': 'Bu ada sahip dosyalar taşınmaz',
  'hostfiles.deniedHint':
    'Kimlik bilgisi biçimindeki adlar reddedilir. Bu bir güvenlik sınırı değil, yanlış satıra tıklamaya karşı bir korkuluktur.',
  'hostfiles.outside': 'Kökün dışını gösteriyor',
  'hostfiles.incomplete': 'Yarım kalmış yükleme',
  'hostfiles.incompleteHint':
    '{size} gönderilmiş. Aynı dosyayı yeniden bırakırsanız kaldığı yerden devam eder; ya da atın.',
  'hostfiles.discard': 'At',
  'hostfiles.transfers': 'Aktarımlar',
  'hostfiles.state.queued': 'Sırada',
  'hostfiles.state.hashing': 'Özet alınıyor',
  'hostfiles.state.sending': 'Gönderiliyor',
  'hostfiles.state.finishing': 'Doğrulanıyor',
  'hostfiles.state.done': 'Bitti',
  'hostfiles.state.failed': 'Başarısız',
  'hostfiles.state.cancelled': 'Vazgeçildi',
  'hostfiles.folderNeedsFolder':
    'Bir klasörü indirmek için önce solda bir hedef klasör seçin. Tarayıcının indirilenler kutusuna klasör yapısı korunarak yazılamaz.',
  'hostfiles.treeTooBig':
    '“{name}” tek seferde taşınamayacak kadar çok dosya içeriyor. İçindeki alt klasörleri ayrı ayrı taşıyın.',
  'hostfiles.someSkipped':
    'Klasördeki {count} öğe taşınmadı: bunlar ya kökün dışını gösteren bağlantılar ya da kimlik bilgisi biçiminde adlar.',
  'hostfiles.folderWorking':
    'Klasör taranıyor ve taşınıyor — dosyalar aşağıdaki sıraya düşecek.',
  'hostfiles.resizePanes': 'Panellerin genişliğini ayarla',
  'hostfiles.resizePanesValue': 'Sol panel %{pct}',
  'hostfiles.resizeQueue': 'Kuyruğun yüksekliğini ayarla',
  'hostfiles.resizeQueueValue': '{px} piksel',
  'hostfiles.parallel': 'Aynı anda kaç aktarım',
  'hostfiles.parallelN': '{n} eşzamanlı',
  'hostfiles.stop': 'Durdur',
  'hostfiles.stopAll': 'Tümünü durdur',
  'hostfiles.batchRunning': 'sürüyor',
  'hostfiles.batchQueued': 'sırada',
  'hostfiles.queueMore': 've sırada {n} dosya daha.',
  'hostfiles.newFolder': 'Yeni klasör',
  'hostfiles.newFolderName': 'Klasör adı',
  'hostfiles.rename': 'Yeniden adlandır',
  'hostfiles.renameTo': 'Yeni ad',
  'hostfiles.remove': 'Sil',
  'hostfiles.removeTitle': 'Sunucudan sil',
  'hostfiles.removeConfirm': '{files} dosya ve {dirs} klasör sunucudan kalıcı olarak silinecek. Çöp kutusu yok, geri alma yok.',
  'hostfiles.removeTruncated': '“{name}” gösterilenden fazlasını tutuyor; ne silineceği bilinmediği için silinmiyor. Alt klasörleri ayrı ayrı silin.',
  'hostfiles.removeTooMany': '“{name}” {count} öğe içeriyor — buradan tek seferde silinemeyecek kadar çok. Bu boyutta bir silme terminalde yapılmalı.',
  'hostfiles.removeDenied':
    '“{item}” kimlik bilgisi biçiminde bir ad taşıyor; seçilenlerin hiçbiri silinmedi.',
  'hostfiles.removeRoot': 'Kökün kendisi silinemez.',
  'hostfiles.opNotEmpty': 'Klasör boş değil. İçinde görünmeyen bir şey olabilir — yarım kalmış bir yükleme listede gösterilmez.',
  'hostfiles.opNameTaken': 'Bu adla bir şey zaten var; üzerine yazılmaz.',
  // Its own sentence rather than the `readOnlyRoot` badge. That key is the two
  // words that sit beside a pane header — reused as a refusal it put the
  // notice strip's whole content at “salt okunur”, which names a property and
  // not what just happened to the click.
  'hostfiles.opReadOnly':
    'Bu kök salt okunur olarak kayıtlı; buraya hiçbir şey yazılmaz. Liste okunduğundan beri değişmiş olabilir.',
  'hostfiles.opChecksum':
    'Sunucuya ulaşan baytlar gönderilenlerle eşleşmiyor; hiçbir şey yazılmadı. Yarım dosya da silindi, aktarım baştan başlar.',
  'hostfiles.rootGone':
    'Bu kök sunucuda yok. Disk bağlı değilse ya da dizin taşınmışsa böyle görünür.',
  'hostfiles.opNotAnEntry': 'Bu, bu ekranın taşıdığı türden bir öğe değil.',
  'hostfiles.replaceTitle': 'Üzerine yazılsın mı?',
  'hostfiles.replaceAsk': 'Sunucuda “{name}” adında bir dosya zaten var.',
  'hostfiles.replaceYes': 'Üzerine yaz',
  'hostfiles.replaceSkip': 'Atla',
  'hostfiles.replaceAll': 'Kalan dosyalar için de aynısını yap',
  'hostfiles.state.skipped': 'Atlandı',
  'hostfiles.outsideHint': 'Bu ad kökün dışını gösteriyor; içeriği buradan taşınmaz.',
  'hostfiles.opNoRoot': 'Bu kök sunucuda yok.',
  'hostfiles.downloadFailed': 'Dosya alınamadı (sunucu {status} döndü).',
  'hostfiles.leaveWarning': 'Süren aktarım var.',

} as const
